// src/constantes.ts
var ROLES = ["admin", "encargado", "chofer", "preventista"];
var MEDIOS_COBRO = ["efectivo", "qr", "transferencia", "cuenta_corriente"];
var MEDIO_COBRO_ETIQUETA = {
  efectivo: "Efectivo",
  qr: "QR",
  transferencia: "Transferencia",
  cuenta_corriente: "Cuenta corriente"
};
var ESTADOS_PEDIDO = [
  "pendiente",
  "asignado",
  "cargado",
  "en_ruta",
  "entregado",
  "parcial",
  "no_entregado",
  "anulado"
];
var ESTADO_PEDIDO_ETIQUETA = {
  pendiente: "Pendiente",
  asignado: "Asignado",
  cargado: "Cargado",
  en_ruta: "En ruta",
  entregado: "Entregado",
  parcial: "Parcial",
  no_entregado: "No entregado",
  anulado: "Anulado"
};
var ESTADOS_RUTA = ["armada", "en_curso", "cerrada"];
var RESULTADOS_PARADA = ["pendiente", "entregada", "parcial", "no_entregada"];
var MOTIVOS_NO_ENTREGA = [
  "cerrado",
  "rechazo",
  "no_estaba",
  "direccion_incorrecta",
  "sin_visitar",
  "otro"
];
var MOTIVO_NO_ENTREGA_ETIQUETA = {
  cerrado: "Cerrado",
  rechazo: "Rechaz\xF3",
  no_estaba: "No estaba",
  direccion_incorrecta: "Direcci\xF3n incorrecta",
  sin_visitar: "Sin visitar",
  otro: "Otro"
};
var TIPOS_COMPROBANTE = ["firma", "foto"];
var ESTADOS_RENDICION = ["pendiente_recepcion", "recibida"];
var ORIGENES_UBICACION = ["ninguna", "geocodificada", "gps_chofer", "manual", "cliente"];
var UBICACION_VERIFICADA = ["gps_chofer", "manual"];
var ORIGENES_UBICACION_PANEL = ["manual", "cliente", "geocodificada"];
var UNIDADES_BULTO = ["caja", "fardo", "pack", "display", "bolsa", "unidad"];
var TIPOS_MOVIL = ["camioneta", "camion_chico", "camion"];
var ORIGENES_CLIENTE = ["distribuidora", "tienda"];
var ESTADOS_CLIENTE_TIENDA = ["pendiente", "aprobado", "bloqueado"];
var ESTADO_CLIENTE_TIENDA_ETIQUETA = {
  pendiente: "Por aprobar",
  aprobado: "Aprobado",
  bloqueado: "Bloqueado"
};
var ORIGENES_PEDIDO = ["panel", "importacion", "api", "app_preventista", "tienda"];
var ESTADOS_PEDIDO_VENTA = ["por_aprobar", "aprobado", "rechazado", "cancelado"];
var ESTADO_PEDIDO_VENTA_ETIQUETA = {
  por_aprobar: "Por aprobar",
  aprobado: "Aprobado",
  rechazado: "Rechazado",
  cancelado: "Cancelado por el cliente"
};
var DIAS_SEMANA = ["dom", "lun", "mar", "mie", "jue", "vie", "sab"];
var DIA_SEMANA_ETIQUETA = {
  dom: "Domingo",
  lun: "Lunes",
  mar: "Martes",
  mie: "Mi\xE9rcoles",
  jue: "Jueves",
  vie: "Viernes",
  sab: "S\xE1bado"
};
var TIPOS_OPERACION_SYNC = [
  "tildar",
  "cargar_item",
  "confirmar_carga",
  "reordenar",
  "optimizar",
  "salir",
  "llegada",
  "entregar",
  "no_entregar",
  "cerrar",
  "fijar_ubicacion_cliente"
];
var TIPOS_IMPORTACION = ["clientes", "articulos", "precios", "moviles", "pedidos"];
var TIPOS_ALERTA = [
  "movil_sin_posiciones",
  "movil_detenido",
  "diferencia_rendicion",
  "documento_por_vencer",
  "pedido_sin_movil",
  "desvio_ruta",
  "entrega_lejos",
  "entregas_rapidas",
  "velocidad_excesiva",
  "bateria_baja",
  "diferencias_recurrentes",
  "cliente_problematico",
  "ventana_en_riesgo",
  "capacidad_superada",
  /** La estación de impresión de un depósito no responde y hay trabajos esperando (decisión D56). */
  "estacion_sin_respuesta",
  /** Factura electrónica (decisión D58): SIFEN rechazó documentos que hay que corregir o anular. */
  "sifen_rechazado",
  /** Documentos firmados que no se pudieron mandar a SIFEN en 24 horas (el plazo es de 72). */
  "sifen_sin_enviar",
  /** El certificado digital de la empresa vence en menos de 30 días (o venció). */
  "certificado_por_vencer"
];
var ALERTAS_FACTURACION = [
  "sifen_rechazado",
  "sifen_sin_enviar",
  "certificado_por_vencer"
];
var URGENCIAS = ["baja", "media", "alta"];
var CODIGOS_ERROR = [
  "VALIDACION",
  "NO_AUTENTICADO",
  "SIN_PERMISO",
  "NO_EXISTE",
  "TRANSICION_INVALIDA",
  "DUPLICADO",
  "PEDIDO_NO_EDITABLE",
  /** Otra persona guardó el pedido mientras tanto (control de versión, decisión D52): hay que revisarlo. */
  "PEDIDO_CAMBIO",
  "CAPACIDAD_SUPERADA",
  "COMPROBANTE_REQUERIDO",
  "MEDIO_NO_HABILITADO",
  "CARGA_VACIA",
  /** La carga cambió desde que se la miró (decisión D54): hay que revisarla y volver a dar la conformidad. */
  "CARGA_CAMBIO",
  /** Con `carga.quien_tilda` en `ambos` o `encargado`, la ruta no sale sin la carga cerrada (decisión D54). */
  "CARGA_SIN_CIERRE",
  "RUTA_EXISTENTE",
  "OTP_INVALIDO",
  "OTP_BLOQUEADO",
  "TOKEN_REVOCADO",
  "LIMITE_EXCEDIDO",
  "REGLA_NEGOCIO",
  "SMS_NO_ENVIADO",
  /** Otra computadora ya es la estación de impresión de ese depósito (decisión D56). */
  "ESTACION_OCUPADA",
  /** Esta computadora ya no es la estación de impresión (otra la reemplazó o la sacaron). */
  "NO_ES_LA_ESTACION",
  // Facturación (decisión D57).
  /** El pedido ya tiene su documento de venta: no se emite otro. */
  "COMPROBANTE_EXISTENTE",
  /** El pedido tiene un comprobante emitido: para cambiarlo o anularlo, primero hay que anular o acreditar el documento. */
  "PEDIDO_FACTURADO",
  /** No hay punto de expedición, timbrado vigente o numeración para ese documento. */
  "SIN_TIMBRADO",
  /** Se llegó al tope de la numeración autorizada del punto de expedición. */
  "NUMERACION_AGOTADA",
  // Factura electrónica (decisión D58).
  /** Pasó el plazo para cancelar en SIFEN (factura 48 h; otros, 168 h): se corrige con una nota de crédito. */
  "FUERA_DE_PLAZO",
  /** SIFEN no respondió o rechazó el pedido; el detalle va en el mensaje. */
  "SIFEN",
  // Padrón de la DNIT (decisión D61).
  /** Lo escrito no puede ser un RUC ni una cédula (422). */
  "RUC_INVALIDO",
  /** El padrón de la DNIT no está cargado en este servidor (503): no se sabe si figura, se carga a mano. */
  "PADRON_NO_CARGADO",
  "ERROR_INTERNO"
];

// src/maquinas.ts
var PEDIDO = {
  pendiente: ["asignado", "anulado"],
  asignado: ["pendiente", "cargado", "anulado"],
  cargado: ["en_ruta", "asignado"],
  en_ruta: ["entregado", "parcial", "no_entregado"],
  entregado: ["en_ruta"],
  parcial: ["en_ruta"],
  no_entregado: ["en_ruta"],
  anulado: []
};
var RUTA = {
  armada: ["en_curso"],
  en_curso: ["cerrada"],
  cerrada: []
};
var PARADA = {
  pendiente: ["entregada", "parcial", "no_entregada"],
  entregada: ["pendiente"],
  parcial: ["pendiente"],
  no_entregada: ["pendiente"]
};
var RENDICION = {
  pendiente_recepcion: ["recibida"],
  recibida: []
};
var PEDIDO_VENTA = {
  por_aprobar: ["aprobado", "rechazado", "cancelado"],
  aprobado: [],
  rechazado: [],
  cancelado: []
};
var MAQUINAS = {
  pedido: PEDIDO,
  ruta: RUTA,
  parada: PARADA,
  rendicion: RENDICION,
  pedido_venta: PEDIDO_VENTA
};
function puedeTransicionar(maquina, de, a) {
  const tabla = MAQUINAS[maquina];
  return tabla[de]?.includes(a) ?? false;
}
var PEDIDO_EDITABLE = ["pendiente", "asignado"];

// src/fiscal.ts
var TIPOS_DOCUMENTO_FISCAL = [
  "interno",
  "nota_venta",
  "factura",
  "nota_credito",
  "nota_debito",
  "remision"
];
var TIPO_DOCUMENTO_FISCAL_ETIQUETA = {
  interno: "Comprobante interno",
  nota_venta: "Nota de venta",
  factura: "Factura",
  nota_credito: "Nota de cr\xE9dito",
  nota_debito: "Nota de d\xE9bito",
  remision: "Nota de remisi\xF3n"
};
var TIPOS_VENTA = ["interno", "nota_venta", "factura"];
var esTipoVenta = (t) => TIPOS_VENTA.includes(t);
var TIPOS_CON_TIMBRADO = [
  "nota_venta",
  "factura",
  "nota_credito",
  "nota_debito",
  "remision"
];
var ESTADOS_COMPROBANTE = ["emitido", "anulado", "provisorio", "pendiente", "propuesto"];
var ESTADO_COMPROBANTE_ETIQUETA = {
  emitido: "Emitido",
  anulado: "Anulado",
  provisorio: "Provisorio",
  pendiente: "Pendiente de emitir",
  propuesto: "Propuesto"
};
var EMISORES = ["local", "sifen", "externo"];
var CONDICIONES_VENTA = ["contado", "credito"];
var CONDICION_VENTA_ETIQUETA = { contado: "Contado", credito: "Cr\xE9dito" };
var condicionDeCobro = (cobro) => cobro === "cuenta_corriente" ? "credito" : "contado";
var DOCUMENTOS_VENTA_CONFIG = [
  "interno",
  "nota_venta",
  "autoimpresor",
  "electronica",
  "otro_sistema"
];
var DOCUMENTO_VENTA_CONFIG_ETIQUETA = {
  interno: "Comprobante interno",
  nota_venta: "Nota de venta",
  autoimpresor: "Factura autoimpresor",
  electronica: "Factura electr\xF3nica (SIFEN)",
  otro_sistema: "La emite otro sistema"
};
var MOMENTOS_FACTURACION = ["aprobar", "cargar", "entregar", "cobrar", "manual"];
var MOMENTO_FACTURACION_ETIQUETA = {
  aprobar: "Al aprobar el pedido",
  cargar: "Al cerrar la carga",
  entregar: "Al entregar",
  cobrar: "Al cobrar",
  manual: "A mano, desde el panel"
};
var OPCIONES_REMISION = ["nunca", "sin_factura", "siempre"];
var OPCIONES_NOTA_CREDITO = ["automatica", "propuesta", "manual"];
var tipoDeDocumentoConfig = (d) => d === "interno" ? "interno" : d === "nota_venta" ? "nota_venta" : "factura";
var emisorDeDocumentoConfig = (d) => d === "electronica" ? "sifen" : d === "otro_sistema" ? "externo" : "local";
var esDocumentoFiscal = (d) => d !== "interno";
function planFacturacion(f, condicion) {
  const documento = condicion === "credito" ? f.credito_documento : f.contado_documento;
  const momento = condicion === "credito" ? f.credito_momento : f.contado_momento;
  return {
    condicion,
    documento,
    momento,
    tipo: tipoDeDocumentoConfig(documento),
    emisor: emisorDeDocumentoConfig(documento)
  };
}
var viajaSinFactura = (p) => p.momento === "entregar" || p.momento === "cobrar";
function llevaRemision(f, conDocumentoFiscal) {
  if (f.remision === "siempre") return true;
  if (f.remision === "sin_factura") return !conDocumentoFiscal;
  return false;
}
function erroresFacturacion(f) {
  const errores = [];
  for (const c of CONDICIONES_VENTA) {
    const p = planFacturacion(f, c);
    if (esDocumentoFiscal(p.documento) && viajaSinFactura(p) && f.remision === "nunca") {
      errores.push({
        campo: "remision",
        mensaje: `Con la venta ${c === "credito" ? "a cr\xE9dito" : "al contado"} facturada ${p.momento === "entregar" ? "al entregar" : "al cobrar"}, la mercader\xEDa viaja sin factura: la nota de remisi\xF3n es obligatoria. Eleg\xED "Cuando viaja sin factura" o "Siempre".`
      });
      break;
    }
  }
  if (f.credito_momento === "cobrar" && !f.credito_al_cobrar_confirmado)
    errores.push({
      campo: "credito_al_cobrar_confirmado",
      mensaje: 'Facturar las ventas a cr\xE9dito reci\xE9n al cobrar lo tiene que confirmar el contador: la factura a cr\xE9dito normalmente sale con la venta. Marc\xE1 "El contador lo confirm\xF3" para guardarlo.'
    });
  return errores;
}
function avisosFacturacion(f) {
  const avisos = [];
  const planes = CONDICIONES_VENTA.map((c) => planFacturacion(f, c));
  if (planes.some((p) => p.documento === "electronica")) {
    avisos.push(
      'La factura electr\xF3nica (SIFEN) todav\xEDa no est\xE1 conectada: los documentos quedan "pendientes de emitir" hasta que la empresa tenga el certificado y se habilite.'
    );
    if (planes.some((p) => p.documento === "electronica" && viajaSinFactura(p)))
      avisos.push(
        "La factura electr\xF3nica se firma en el servidor: si el chofer entrega sin se\xF1al, deja un comprobante provisorio y la factura sale al volver la se\xF1al. Si eso no sirve, conviene facturar al cerrar la carga."
      );
  }
  if (planes.some((p) => p.documento === "otro_sistema"))
    avisos.push(
      'Con "La emite otro sistema", los documentos quedan pendientes hasta que el conector con ese sistema est\xE9 listo. Cada sistema tiene que usar su propio punto de expedici\xF3n.'
    );
  if (planes.some((p) => p.documento === "nota_venta" || p.documento === "autoimpresor"))
    avisos.push(
      "La nota de venta y la factura autoimpresor dependen del r\xE9gimen y de la obligatoriedad de SIFEN de la empresa: confirmalo con el contador antes de usarlas de verdad."
    );
  if (f.credito_momento === "cobrar")
    avisos.push(
      "Los recibos de cuenta corriente todav\xEDa no existen: hasta entonces, las ventas a cr\xE9dito se facturan a mano desde el panel."
    );
  if (f.nota_debito_envase || f.nota_debito_bancard || f.nota_debito_mora)
    avisos.push(
      "Las notas de d\xE9bito por envase, Bancard o mora quedan guardadas pero todav\xEDa no salen solas: esas partes del sistema no existen. Mientras tanto se emiten a mano."
    );
  return avisos;
}
function calcularDvRuc(base, baseMax = 11) {
  let numeros = "";
  for (const c of base.toUpperCase()) {
    const codigo = c.charCodeAt(0);
    numeros += codigo >= 48 && codigo <= 57 ? c : String(codigo);
  }
  let k = 2;
  let total = 0;
  for (let i = numeros.length - 1; i >= 0; i--) {
    if (k > baseMax) k = 2;
    total += Number(numeros[i]) * k;
    k++;
  }
  const resto = total % 11;
  return resto > 1 ? 11 - resto : 0;
}
function separarRuc(texto2) {
  const limpio = texto2.trim().toUpperCase().replace(/[.\s]/g, "");
  const m = /^([0-9A-Z]+)(?:-([0-9]))?$/.exec(limpio);
  if (!m) return { base: limpio.replace(/-/g, ""), dv: null };
  return { base: m[1], dv: m[2] ?? null };
}
function errorRuc(texto2) {
  const limpio = texto2.trim().toUpperCase().replace(/[.\s]/g, "");
  if (!/^[0-9A-Z]{3,12}-[0-9]$/.test(limpio))
    return "Escrib\xED el RUC con su d\xEDgito verificador, separado con un guion (ej. 80069563-1)";
  const { base, dv } = separarRuc(limpio);
  if (!/\d/.test(base)) return "El RUC tiene que tener n\xFAmeros";
  const esperado = calcularDvRuc(base);
  if (Number(dv) !== esperado) return `El d\xEDgito verificador no coincide: para ${base} es ${esperado}`;
  return null;
}
function normalizarRuc(texto2) {
  const { base, dv } = separarRuc(texto2);
  return dv === null ? base : `${base}-${dv}`;
}
var TIPOS_DOCUMENTO_IDENTIDAD = ["ruc", "ci", "pasaporte", "consumidor_final"];
var TIPO_DOCUMENTO_IDENTIDAD_ETIQUETA = {
  ruc: "RUC",
  ci: "C\xE9dula",
  pasaporte: "Pasaporte",
  consumidor_final: "Consumidor final (sin nombre)"
};
function errorDocumentoFiscal(tipo, documento) {
  const d = documento?.trim() ?? "";
  if (!tipo || tipo === "consumidor_final") return null;
  if (!d) return tipo === "ruc" ? "Escrib\xED el RUC con su d\xEDgito verificador" : "Escrib\xED el n\xFAmero de documento";
  if (tipo === "ruc") return errorRuc(d);
  if (tipo === "ci" && !/^[0-9][0-9.]*$/.test(d)) return "La c\xE9dula va solo con n\xFAmeros (puede llevar puntos)";
  return null;
}
function tipoDocumentoProbable(documento) {
  const d = documento?.trim() ?? "";
  if (!d) return "consumidor_final";
  if (!errorRuc(d)) return "ruc";
  return /^[0-9][0-9.]*$/.test(d) ? "ci" : "pasaporte";
}
var TASAS_IVA = [10, 5, 0];
var TASA_IVA_ETIQUETA = { 10: "IVA 10 %", 5: "IVA 5 %", 0: "Exento" };
function liquidarIva(renglones) {
  let gravado10 = 0;
  let gravado5 = 0;
  let exento = 0;
  for (const r of renglones) {
    if (r.tasa === 10) gravado10 += r.total;
    else if (r.tasa === 5) gravado5 += r.total;
    else exento += r.total;
  }
  const iva10 = Math.round(gravado10 / 11);
  const iva5 = Math.round(gravado5 / 21);
  return {
    gravado_10: gravado10,
    gravado_5: gravado5,
    exento,
    iva_10: iva10,
    iva_5: iva5,
    iva_total: iva10 + iva5,
    total: gravado10 + gravado5 + exento
  };
}
var totalRenglon = (r) => r.cantidad * r.precio_unitario;
function liquidarRenglones(renglones) {
  return liquidarIva(renglones.map((r) => ({ total: totalRenglon(r), tasa: r.tasa })));
}
var codigoTresDigitos = (n) => String(n).replace(/\D/g, "").padStart(3, "0");
function formatoNumeroComprobante(establecimiento, punto, numero) {
  return `${codigoTresDigitos(establecimiento)}-${codigoTresDigitos(punto)}-${String(numero).padStart(7, "0")}`;
}
function siguienteDeReserva(reserva, usadosLocales = []) {
  const usados = /* @__PURE__ */ new Set([...reserva.usados, ...usadosLocales]);
  for (let n = reserva.desde; n <= reserva.hasta; n++) if (!usados.has(n)) return n;
  return null;
}
function noUsadosDeReserva(reserva) {
  const usados = new Set(reserva.usados);
  const salida = [];
  for (let n = reserva.desde; n <= reserva.hasta; n++) if (!usados.has(n)) salida.push(n);
  return salida;
}
function diferenciaNotaCredito(facturado, entregados, acreditados) {
  const salida = [];
  for (const r of facturado) {
    if (!r.pedido_item_id) continue;
    const entregado = entregados.get(r.pedido_item_id) ?? 0;
    const acreditado = acreditados.get(r.id) ?? 0;
    const falta = r.cantidad - entregado - acreditado;
    if (falta > 0) salida.push({ comprobante_item_id: r.id, cantidad: falta });
  }
  return salida;
}
var UNIDADES = ["", "uno", "dos", "tres", "cuatro", "cinco", "seis", "siete", "ocho", "nueve"];
var DIEZ_A_VEINTINUEVE = [
  "diez",
  "once",
  "doce",
  "trece",
  "catorce",
  "quince",
  "diecis\xE9is",
  "diecisiete",
  "dieciocho",
  "diecinueve",
  "veinte",
  "veintiuno",
  "veintid\xF3s",
  "veintitr\xE9s",
  "veinticuatro",
  "veinticinco",
  "veintis\xE9is",
  "veintisiete",
  "veintiocho",
  "veintinueve"
];
var DECENAS = ["", "", "", "treinta", "cuarenta", "cincuenta", "sesenta", "setenta", "ochenta", "noventa"];
var CENTENAS = [
  "",
  "ciento",
  "doscientos",
  "trescientos",
  "cuatrocientos",
  "quinientos",
  "seiscientos",
  "setecientos",
  "ochocientos",
  "novecientos"
];
function hastaMil(n, apocope) {
  if (n === 100) return "cien";
  const c = Math.floor(n / 100);
  const r = n % 100;
  let resto = "";
  if (r > 0 && r < 10) resto = UNIDADES[r];
  else if (r >= 10 && r < 30) resto = DIEZ_A_VEINTINUEVE[r - 10];
  else if (r >= 30) resto = `${DECENAS[Math.floor(r / 10)]}${r % 10 ? ` y ${UNIDADES[r % 10]}` : ""}`;
  if (apocope) resto = resto.replace(/veintiuno$/, "veinti\xFAn").replace(/uno$/, "un");
  return [CENTENAS[c], resto].filter(Boolean).join(" ");
}
function hastaMillon(n, apocope) {
  const miles = Math.floor(n / 1e3);
  const resto = n % 1e3;
  const partes2 = [];
  if (miles === 1) partes2.push("mil");
  else if (miles > 1) partes2.push(`${hastaMil(miles, true)} mil`);
  if (resto) partes2.push(hastaMil(resto, apocope));
  return partes2.join(" ");
}
function numeroALetras(valor) {
  const n = Math.trunc(Math.abs(valor));
  if (n === 0) return "cero";
  const millones = Math.floor(n / 1e6);
  const resto = n % 1e6;
  const partes2 = [];
  if (millones === 1) partes2.push("un mill\xF3n");
  else if (millones > 1) partes2.push(`${hastaMillon(millones, true)} millones`);
  if (resto) partes2.push(hastaMillon(resto, false));
  return partes2.join(" ");
}
function totalEnLetras(total) {
  return `Guaran\xEDes ${numeroALetras(total)}`;
}

// src/geo.ts
var PARAMETROS_RUTA_POR_DEFECTO = { factorCalle: 1.35, velocidadKmh: 35, minutosPorParada: 7 };
var RADIO_TIERRA_KM = 6371.0088;
var rad = (g) => g * Math.PI / 180;
function haversineKm(a, b) {
  const dLat = rad(b.lat - a.lat);
  const dLng = rad(b.lng - a.lng);
  const x = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * RADIO_TIERRA_KM * Math.asin(Math.min(1, Math.sqrt(x)));
}
var haversineM = (a, b) => haversineKm(a, b) * 1e3;
function puntoDeParada(p, deposito) {
  return p.ubicacion ?? p.ubicacionAproximada ?? deposito;
}
var aMinutos = (hhmm) => {
  const [h, m] = hhmm.split(":").map(Number);
  return (h ?? 0) * 60 + (m ?? 0);
};
var deMinutos = (min) => {
  const m = Math.max(0, Math.round(min)) % (24 * 60);
  return `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
};
function tramoViaje(a, b, params, matriz) {
  const t = matriz?.tramo(a, b);
  if (t) return t;
  const km = haversineKm(a, b) * params.factorCalle;
  return { km, min: km / params.velocidadKmh * 60 };
}
function metricasRuta(deposito, paradas, params = PARAMETROS_RUTA_POR_DEFECTO, opciones = {}) {
  let actual = opciones.inicio ?? deposito;
  let km = 0;
  let minutos = 0;
  const salida = opciones.horaSalida ? aMinutos(opciones.horaSalida) : null;
  const llegadas = [];
  for (const p of paradas) {
    const destino = puntoDeParada(p, deposito);
    const tramo = tramoViaje(actual, destino, params, opciones.matriz);
    km += tramo.km;
    minutos += tramo.min;
    const minutoLlegada = minutos;
    const llegadaAbs = salida !== null ? salida + minutoLlegada : null;
    const fuera = llegadaAbs !== null && p.ventanaHasta != null && p.ventanaHasta !== "" ? llegadaAbs > aMinutos(p.ventanaHasta) : false;
    if (llegadaAbs !== null && p.ventanaDesde) {
      const espera = aMinutos(p.ventanaDesde) - llegadaAbs;
      if (espera > 0) minutos += espera;
    }
    llegadas.push({
      id: p.id,
      minuto: Math.round(minutoLlegada),
      llegada: llegadaAbs !== null ? deMinutos(llegadaAbs) : "",
      fueraDeVentana: fuera
    });
    minutos += p.minutosServicio ?? params.minutosPorParada;
    actual = destino;
  }
  if (paradas.length) {
    const vuelta = tramoViaje(actual, deposito, params, opciones.matriz);
    km += vuelta.km;
    minutos += vuelta.min;
  }
  return { km: Math.round(km * 10) / 10, minutos: Math.round(minutos), llegadas };
}
function optimizarOrden(deposito, paradas, params = PARAMETROS_RUTA_POR_DEFECTO, opciones = {}) {
  const fijadas = paradas.filter((p) => p.fijada);
  const libres = paradas.filter((p) => !p.fijada);
  const ubic = (p) => puntoDeParada(p, deposito);
  const ultimaFijada = fijadas.at(-1);
  const inicio = opciones.inicio ?? (ultimaFijada ? ubic(ultimaFijada) : deposito);
  const dist = (a, b) => opciones.matriz?.tramo(a, b)?.km ?? haversineKm(a, b);
  const largo = (seq) => {
    let km = 0;
    let actual = inicio;
    for (const p of seq) {
      km += dist(actual, ubic(p));
      actual = ubic(p);
    }
    return km + (seq.length ? dist(actual, deposito) : 0);
  };
  const vecinoMasCercano = (desde, grupo) => {
    const resto = [...grupo];
    const salida = [];
    let actual = desde;
    while (resto.length) {
      let mejor = 0;
      let mejorD = Infinity;
      resto.forEach((p, i) => {
        const d = dist(actual, ubic(p));
        if (d < mejorD) {
          mejorD = d;
          mejor = i;
        }
      });
      const [elegida] = resto.splice(mejor, 1);
      if (!elegida) break;
      salida.push(elegida);
      actual = ubic(elegida);
    }
    return salida;
  };
  let secuencia;
  if (opciones.respetarZonas) {
    const grupos = /* @__PURE__ */ new Map();
    for (const p of libres) {
      const k = p.zonaId ?? "_";
      grupos.set(k, [...grupos.get(k) ?? [], p]);
    }
    const centro = (g) => ({
      lat: g.reduce((s, p) => s + ubic(p).lat, 0) / g.length,
      lng: g.reduce((s, p) => s + ubic(p).lng, 0) / g.length
    });
    secuencia = [];
    let actual = inicio;
    const pendientes = [...grupos.values()];
    while (pendientes.length) {
      pendientes.sort((a, b) => haversineKm(actual, centro(a)) - haversineKm(actual, centro(b)));
      const g = pendientes.shift();
      if (!g) break;
      const orden = vecinoMasCercano(actual, g);
      secuencia.push(...orden);
      const ultima = orden.at(-1);
      if (ultima) actual = ubic(ultima);
    }
  } else {
    secuencia = vecinoMasCercano(inicio, libres);
  }
  const limite = opciones.limiteMs ?? 2e3;
  const t0 = Date.now();
  let mejorKm = largo(secuencia);
  let mejoro = true;
  while (mejoro && Date.now() - t0 < limite) {
    mejoro = false;
    for (let i = 0; i < secuencia.length - 1; i++) {
      for (let j = i + 1; j < secuencia.length; j++) {
        if (opciones.respetarZonas && secuencia[i]?.zonaId !== secuencia[j]?.zonaId) continue;
        const candidata = [...secuencia.slice(0, i), ...secuencia.slice(i, j + 1).reverse(), ...secuencia.slice(j + 1)];
        const km = largo(candidata);
        if (km < mejorKm - 0.05) {
          secuencia = candidata;
          mejorKm = km;
          mejoro = true;
        }
      }
    }
  }
  if (largo(libres) < largo(secuencia)) secuencia = [...libres];
  let ordenFinal = [...fijadas, ...secuencia];
  const riesgo = /* @__PURE__ */ new Set();
  if (opciones.horaSalida) {
    const fuera = (seq) => metricasRuta(deposito, seq, params, {
      horaSalida: opciones.horaSalida,
      inicio: opciones.inicio,
      matriz: opciones.matriz
    }).llegadas.filter((l) => l.fueraDeVentana);
    for (const tarde of fuera(ordenFinal)) {
      const idx = ordenFinal.findIndex((p) => p.id === tarde.id);
      const parada = ordenFinal[idx];
      if (!parada) continue;
      const base = fuera(ordenFinal).length;
      let movida = false;
      for (let pos = fijadas.length; pos < idx; pos++) {
        const sin = ordenFinal.filter((_, k) => k !== idx);
        const prueba = [...sin.slice(0, pos), parada, ...sin.slice(pos)];
        if (fuera(prueba).length < base) {
          ordenFinal = prueba;
          movida = true;
          break;
        }
      }
      if (!movida) riesgo.add(parada.id);
    }
    for (const l of fuera(ordenFinal)) riesgo.add(l.id);
  }
  const original = metricasRuta(deposito, paradas, params, { inicio: opciones.inicio, matriz: opciones.matriz });
  const final = metricasRuta(deposito, ordenFinal, params, {
    inicio: opciones.inicio,
    horaSalida: opciones.horaSalida,
    matriz: opciones.matriz
  });
  return {
    orden: ordenFinal.map((p) => p.id),
    kmAntes: original.km,
    kmDespues: final.km,
    minutosDespues: final.minutos,
    ventanasEnRiesgo: [...riesgo]
  };
}
function enlacesGoogleMaps(deposito, puntos, porTramo = 23) {
  const f = (p) => `${p.lat.toFixed(6)},${p.lng.toFixed(6)}`;
  if (!puntos.length) return [];
  const tramos = [];
  for (let i = 0; i < puntos.length; i += porTramo) {
    const tramo = puntos.slice(i, i + porTramo);
    const desde = i === 0 ? deposito : puntos[i - 1];
    const esUltimo = i + porTramo >= puntos.length;
    const secuencia = [desde, ...tramo, ...esUltimo ? [deposito] : []].filter((p) => Boolean(p));
    tramos.push(`https://www.google.com/maps/dir/${secuencia.map(f).join("/")}`);
  }
  return tramos;
}
function enlaceNavegar(destino) {
  return `https://www.google.com/maps/dir/?api=1&destination=${destino.lat.toFixed(6)},${destino.lng.toFixed(6)}&travelmode=driving`;
}
function simplificarRecorrido(puntos, toleranciaM = 15) {
  if (puntos.length < 3) return [...puntos];
  const distanciaASegmento = (p, a, b) => {
    const kx = 111320 * Math.cos(rad((a.lat + b.lat) / 2));
    const ky = 110540;
    const ax = a.lng * kx, ay = a.lat * ky, bx = b.lng * kx, by = b.lat * ky, px = p.lng * kx, py = p.lat * ky;
    const dx = bx - ax, dy = by - ay;
    const largo2 = dx * dx + dy * dy;
    const t = largo2 === 0 ? 0 : Math.max(0, Math.min(1, ((px - ax) * dx + (py - ay) * dy) / largo2));
    return Math.hypot(px - (ax + t * dx), py - (ay + t * dy));
  };
  const conservar = new Array(puntos.length).fill(false);
  conservar[0] = true;
  conservar[puntos.length - 1] = true;
  const pila = [[0, puntos.length - 1]];
  while (pila.length) {
    const [i, j] = pila.pop();
    let maxD = 0;
    let idx = -1;
    for (let k = i + 1; k < j; k++) {
      const d = distanciaASegmento(puntos[k], puntos[i], puntos[j]);
      if (d > maxD) {
        maxD = d;
        idx = k;
      }
    }
    if (idx >= 0 && maxD > toleranciaM) {
      conservar[idx] = true;
      pila.push([i, idx], [idx, j]);
    }
  }
  return puntos.filter((_, k) => conservar[k]);
}
function kmRecorridos(posiciones, { precisionMaximaM = 50, velocidadMaximaKmh = 150 } = {}) {
  const validas = posiciones.filter((p) => p.precisionM == null || p.precisionM <= precisionMaximaM).map((p) => ({ ...p, t: new Date(p.hora).getTime() })).sort((a, b) => a.t - b.t);
  let km = 0;
  let previa = validas[0];
  for (const p of validas.slice(1)) {
    if (!previa) break;
    const d = haversineKm(previa, p);
    const horas = (p.t - previa.t) / 36e5;
    if (horas > 0 && d / horas > velocidadMaximaKmh) continue;
    km += d;
    previa = p;
  }
  return Math.round(km * 10) / 10;
}

// src/rendicion.ts
function calcularRendicion(paradas) {
  const r = {
    bultos_cargados: 0,
    bultos_entregados: 0,
    bultos_devueltos: 0,
    paradas_total: paradas.length,
    paradas_entregadas: 0,
    paradas_parciales: 0,
    paradas_fallidas: 0,
    paradas_pendientes: 0,
    efectivo_cobrado: 0,
    qr_cobrado: 0,
    transferencia_cobrada: 0,
    cuenta_corriente: 0,
    efectivo_esperado: 0,
    cobrable_esperado: 0,
    diferencia: 0
  };
  for (const p of paradas) {
    const cargados = p.items.reduce((s, i) => s + i.bultosCargados, 0);
    const entregados = p.resultado === "entregada" || p.resultado === "parcial" ? p.items.reduce((s, i) => s + Math.min(i.bultosCargados, Math.max(0, i.bultosEntregados ?? 0)), 0) : 0;
    r.bultos_cargados += cargados;
    r.bultos_entregados += entregados;
    if (p.resultado === "entregada") r.paradas_entregadas++;
    else if (p.resultado === "parcial") r.paradas_parciales++;
    else if (p.resultado === "no_entregada") r.paradas_fallidas++;
    else r.paradas_pendientes++;
    const resuelta = p.resultado === "entregada" || p.resultado === "parcial";
    if (!resuelta || !p.cobro) continue;
    const c = p.cobro;
    switch (c.medio) {
      case "efectivo":
        r.efectivo_cobrado += c.montoCobrado;
        r.efectivo_esperado += c.montoEsperado;
        r.cobrable_esperado += c.montoEsperado;
        break;
      case "qr":
        r.qr_cobrado += c.montoCobrado;
        r.cobrable_esperado += c.montoEsperado;
        break;
      case "transferencia":
        r.transferencia_cobrada += c.montoCobrado;
        r.cobrable_esperado += c.montoEsperado;
        break;
      case "cuenta_corriente":
        r.cuenta_corriente += c.montoACuenta;
        break;
    }
  }
  r.bultos_devueltos = r.bultos_cargados - r.bultos_entregados;
  r.diferencia = r.efectivo_cobrado + r.qr_cobrado + r.transferencia_cobrada - r.cobrable_esperado;
  return r;
}
function resultadoPorBultos(cargados, entregados) {
  if (entregados <= 0) return "no_entregada";
  return entregados >= cargados ? "entregada" : "parcial";
}
function montoEsperado(items) {
  return items.reduce((s, i) => s + Math.max(0, i.bultosEntregados) * i.precioBulto, 0);
}

// src/formato.ts
var ZONA_HORARIA = "America/Asuncion";
function formatoMiles(n) {
  const entero = Math.round(n);
  const signo = entero < 0 ? "-" : "";
  return signo + Math.abs(entero).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
var formatoGs = (n) => `Gs. ${formatoMiles(n)}`;
var partes = (fecha, zona) => {
  const d = typeof fecha === "string" ? new Date(fecha) : fecha;
  const f = new Intl.DateTimeFormat("en-GB", {
    timeZone: zona,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23"
  }).formatToParts(d);
  const v = (t) => f.find((p) => p.type === t)?.value ?? "";
  return { dia: v("day"), mes: v("month"), anio: v("year"), hora: v("hour"), minuto: v("minute") };
};
function formatoFecha(fecha, zona = ZONA_HORARIA) {
  if (typeof fecha === "string" && /^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
    const [a, m, d] = fecha.split("-");
    return `${d}/${m}/${a}`;
  }
  const p = partes(fecha, zona);
  return `${p.dia}/${p.mes}/${p.anio}`;
}
function formatoHora(fecha, zona = ZONA_HORARIA) {
  const p = partes(fecha, zona);
  return `${p.hora}:${p.minuto}`;
}
function hoyISO(zona = ZONA_HORARIA, ahora = /* @__PURE__ */ new Date()) {
  const p = partes(ahora, zona);
  return `${p.anio}-${p.mes}-${p.dia}`;
}
function sumarDias(fechaISO, dias) {
  const d = /* @__PURE__ */ new Date(`${fechaISO}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + dias);
  return d.toISOString().slice(0, 10);
}
var formatoNumeroPedido = (n, formato = "PT-{n}") => formato.replace("{n}", String(n));
function normalizarTelefono(entrada) {
  if (!entrada) return null;
  let d = entrada.replace(/[^\d+]/g, "");
  if (d.startsWith("+")) d = d.slice(1);
  else if (d.startsWith("00")) d = d.slice(2);
  if (d.startsWith("595")) d = d.slice(3);
  if (d.startsWith("0")) d = d.slice(1);
  if (!/^\d{8,10}$/.test(d)) return null;
  return `+595${d}`;
}
var normalizarDocumento = (documento) => documento.toUpperCase().replace(/[^0-9A-Z]/g, "");
var documentoSinVerificador = (documento) => normalizarDocumento(documento.split("-")[0]);
function normalizarTexto(s) {
  return s.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().replace(/[^a-z0-9ñ]+/g, " ").trim();
}

// src/ids.ts
var hex = (b) => b.toString(16).padStart(2, "0");
var cripto = globalThis.crypto;
function uuidv7(ahoraMs = Date.now()) {
  const bytes = new Uint8Array(16);
  cripto.getRandomValues(bytes);
  let ts = ahoraMs;
  for (let i = 5; i >= 0; i--) {
    bytes[i] = ts % 256;
    ts = Math.floor(ts / 256);
  }
  bytes[6] = (bytes[6] ?? 0) & 15 | 112;
  bytes[8] = (bytes[8] ?? 0) & 63 | 128;
  const h = Array.from(bytes, hex).join("");
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
var ES_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

// src/codigos.ts
function normalizarCodigo(crudo) {
  return crudo.replace(/[\r\n\t]/g, "").trim().toUpperCase();
}
function digitoGs1(sinVerificador) {
  let suma = 0;
  const d = sinVerificador.split("").reverse();
  d.forEach((c, i) => suma += Number(c) * (i % 2 === 0 ? 3 : 1));
  return (10 - suma % 10) % 10;
}
function esGtinValido(codigo) {
  if (!/^\d+$/.test(codigo) || ![8, 12, 13, 14].includes(codigo.length)) return false;
  return digitoGs1(codigo.slice(0, -1)) === Number(codigo.at(-1));
}
function tipoCodigo(codigo) {
  const c = normalizarCodigo(codigo);
  if (esGtinValido(c)) {
    if (c.length === 13) return "ean13";
    if (c.length === 8) return "ean8";
    if (c.length === 12) return "upc";
    return "itf14";
  }
  return "interno";
}
function variantesCodigo(crudo) {
  const c = normalizarCodigo(crudo);
  const v = [c];
  if (/^\d{12}$/.test(c)) v.push(`0${c}`);
  if (/^0\d{12}$/.test(c)) v.push(c.slice(1));
  if (/^\d{14}$/.test(c) && c.startsWith("0")) v.push(c.slice(1));
  const soloAlfa = c.replace(/[^A-Z0-9]/g, "");
  if (soloAlfa !== c) v.push(soloAlfa);
  return [...new Set(v)].filter(Boolean);
}
var DetectorRafaga = class {
  constructor(maxPromedioMs = 45, minTeclas = 4) {
    this.maxPromedioMs = maxPromedioMs;
    this.minTeclas = minTeclas;
  }
  maxPromedioMs;
  minTeclas;
  tiempos = [];
  tecla(ahoraMs) {
    const ultimo = this.tiempos.at(-1);
    if (ultimo !== void 0 && ahoraMs - ultimo > 500) this.tiempos = [];
    this.tiempos.push(ahoraMs);
  }
  /** Al recibir Enter: si lo anterior fue una ráfaga de lector. Reinicia el detector. */
  esLector() {
    const t = this.tiempos;
    this.tiempos = [];
    if (t.length < this.minTeclas) return false;
    const promedio = (t.at(-1) - t[0]) / (t.length - 1);
    return promedio <= this.maxPromedioMs;
  }
};
var Antirrebote = class {
  constructor(esperaMs = 1200) {
    this.esperaMs = esperaMs;
  }
  esperaMs;
  ultimos = /* @__PURE__ */ new Map();
  cuenta(codigo, ahoraMs) {
    const antes = this.ultimos.get(codigo);
    this.ultimos.set(codigo, ahoraMs);
    return antes === void 0 || ahoraMs - antes >= this.esperaMs;
  }
};

// src/enlaces.ts
var TIPOS_ENTIDAD = ["pedido", "cliente", "articulo", "movil", "ruta", "rendicion"];
function rutaPanel(tipo, id) {
  switch (tipo) {
    case "pedido":
      return `/pedidos?ver=${id}`;
    case "cliente":
      return `/clientes/${id}`;
    case "articulo":
      return `/articulos?articulo=${id}`;
    case "movil":
      return `/moviles/${id}`;
    case "ruta":
      return `/rutas/${id}`;
    case "rendicion":
      return `/rendiciones/${id}`;
  }
}
var rutaHojaCarga = (movilId, fecha) => `/pedidos/hoja-carga?movil=${movilId}&fecha=${fecha}`;
var enlacePanel = (base, ruta) => `${base.replace(/\/+$/, "")}${ruta}`;
var codigoCorto = (tipo, id) => `RP:${tipo.toUpperCase()}:${id}`;
var UUID = /([0-9a-f]{8})[^0-9a-z]?([0-9a-f]{4})[^0-9a-z]?([0-9a-f]{4})[^0-9a-z]?([0-9a-f]{4})[^0-9a-z]?([0-9a-f]{12})/;
var PALABRAS = /(pedido|cliente|articulo|movil|rendicion|ruta)/g;
var HOJA_CARGA = /hoja[^a-z0-9]?carga/;
var FECHA = /fecha[^a-z0-9]{0,2}(\d{4})[^0-9]?(\d{2})[^0-9]?(\d{2})/;
function interpretarEnlace(texto2) {
  const t = texto2.trim().toLowerCase();
  const m = UUID.exec(t);
  if (!m) return null;
  const id = `${m[1]}-${m[2]}-${m[3]}-${m[4]}-${m[5]}`;
  const antes = t.slice(0, m.index);
  if (HOJA_CARGA.test(antes)) {
    const f = FECHA.exec(t);
    return { tipo: "hoja_carga", id, fecha: f ? `${f[1]}-${f[2]}-${f[3]}` : null };
  }
  const palabras = [...antes.matchAll(PALABRAS)];
  const tipo = palabras.at(-1)?.[1] ?? null;
  return { tipo, id };
}
function numeroPedidoLeido(texto2, formato = "PT-{n}") {
  const alfanumerico = (s) => s.toUpperCase().replace(/[^0-9A-Z]/g, "");
  const t = alfanumerico(normalizarCodigo(texto2));
  const [prefijo = "", sufijo = ""] = formato.split("{n}").map(alfanumerico);
  let medio = null;
  if (/^\d+$/.test(t)) medio = t;
  else if (prefijo || sufijo) {
    if (t.length > prefijo.length + sufijo.length && t.startsWith(prefijo) && t.endsWith(sufijo))
      medio = t.slice(prefijo.length, t.length - sufijo.length);
  }
  return medio && /^\d{1,9}$/.test(medio) ? Number(medio) : null;
}

// src/chat.ts
var esGestion = (r) => r !== "chofer" && r !== "cliente";
function estadoEntregaChat(seq, tipo, autor, lecturas) {
  if (!seq) return "pendiente";
  const compartida = tipo === "deposito" || tipo === "cliente";
  let otros = lecturas.filter((l) => l.usuario_id !== autor.id);
  if (compartida) otros = otros.filter((l) => esGestion(l.rol) !== esGestion(autor.rol));
  if (!otros.length) return "enviado";
  const cumple = (f) => compartida ? otros.some(f) : otros.every(f);
  if (cumple((l) => l.leido_seq >= seq)) return "leido";
  if (cumple((l) => l.recibido_seq >= seq)) return "recibido";
  return "enviado";
}
function duracionAudio(segundos) {
  const s = Math.max(0, Math.round(segundos));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}
function vistaPreviaMensaje(m, max = 120) {
  if (m.eliminado) return "Mensaje eliminado";
  const d = m.datos ?? {};
  const texto2 = (m.texto ?? "").replace(/\s+/g, " ").trim();
  const con = (prefijo) => texto2 ? `${prefijo}: ${texto2}` : prefijo;
  let r;
  switch (m.tipo) {
    case "imagen":
      r = con("\u{1F4F7} Foto");
      break;
    case "archivo":
      r = con(`\u{1F4C4} ${typeof d.nombre === "string" && d.nombre ? d.nombre : "Documento"}`);
      break;
    case "audio":
      r = `\u{1F3A4} Nota de voz${typeof d.duracion_s === "number" ? ` (${duracionAudio(d.duracion_s)})` : ""}`;
      break;
    case "ubicacion":
      r = con("\u{1F4CD} Ubicaci\xF3n");
      break;
    case "referencia":
      r = con(`\u{1F517} ${typeof d.titulo === "string" ? d.titulo : "Referencia"}`);
      break;
    default:
      r = texto2;
  }
  return r.length > max ? `${r.slice(0, max - 1)}\u2026` : r;
}
var MENCION_ASISTENTE = /(^|[\s(¿¡])@(asistente|ia)(?![\p{L}\p{N}_@]|\.[\p{L}\p{N}])/iu;
function mencionaAlAsistente(texto2) {
  return !!texto2 && MENCION_ASISTENTE.test(texto2);
}
function dentroDePlazo(creadoEn, minutos, ahora = /* @__PURE__ */ new Date()) {
  return ahora.getTime() - new Date(creadoEn).getTime() <= minutos * 6e4;
}

// src/tienda.ts
var SLUGS_RESERVADOS = [
  "api",
  "panel",
  "app",
  "www",
  "demo",
  "delivery",
  "admin",
  "tienda",
  "mail",
  "imagen"
];
var PATRON_SLUG = /^[a-z0-9](?:[a-z0-9-]{0,38}[a-z0-9])?$/;
function slugDeHost(host) {
  if (!host) return null;
  const nombre = host.trim().toLowerCase().replace(/:\d+$/, "").replace(/\.$/, "");
  if (!nombre || nombre === "localhost" || /^[\d.]+$/.test(nombre) || nombre.includes(":")) return null;
  const partes2 = nombre.split(".");
  if (partes2.length < 3) return null;
  const slug = partes2[0];
  if (!PATRON_SLUG.test(slug) || SLUGS_RESERVADOS.includes(slug)) return null;
  return slug;
}
function ahoraLocal(zona = ZONA_HORARIA, ahora = /* @__PURE__ */ new Date()) {
  const f = new Intl.DateTimeFormat("en-GB", {
    timeZone: zona,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23"
  }).formatToParts(ahora);
  const v = (t) => f.find((p) => p.type === t)?.value ?? "";
  return { fecha: `${v("year")}-${v("month")}-${v("day")}`, hora: `${v("hour")}:${v("minute")}` };
}
var diaSemana = (fechaISO) => DIAS_SEMANA[(/* @__PURE__ */ new Date(`${fechaISO}T12:00:00Z`)).getUTCDay()];
function fechasEntregaTienda(opciones) {
  const { fecha, hora } = ahoraLocal(opciones.zona, opciones.ahora);
  const cantidad = Math.max(1, opciones.cantidad ?? 1);
  const dias = new Set(opciones.dias_reparto.length ? opciones.dias_reparto : DIAS_SEMANA);
  const fechas = [];
  let d = sumarDias(fecha, hora < opciones.hora_corte ? 1 : 2);
  for (let i = 0; i < 60 && fechas.length < cantidad; i++) {
    if (dias.has(diaSemana(d))) fechas.push(d);
    d = sumarDias(d, 1);
  }
  return fechas;
}
function mediosPagoCliente(medios, permiteCuentaCorriente) {
  return Object.keys(medios).filter(
    (m) => medios[m] && (m !== "cuenta_corriente" || permiteCuentaCorriente)
  );
}
var PASOS_SEGUIMIENTO = ["Recibido", "Confirmado", "En camino", "Entregado"];
function seguimientoPedidoTienda(venta, traslado) {
  if (venta === "por_aprobar")
    return { clave: "por_aprobar", etiqueta: "Esperando confirmaci\xF3n", paso: 1, tono: "espera" };
  if (venta === "rechazado") return { clave: "rechazado", etiqueta: "No aprobado", paso: 1, tono: "error" };
  if (venta === "cancelado") return { clave: "cancelado", etiqueta: "Cancelado", paso: 1, tono: "neutro" };
  switch (traslado) {
    case "cargado":
      return { clave: "preparado", etiqueta: "Preparado para salir", paso: 2, tono: "curso" };
    case "en_ruta":
      return { clave: "en_camino", etiqueta: "En camino", paso: 3, tono: "curso" };
    case "entregado":
      return { clave: "entregado", etiqueta: "Entregado", paso: 4, tono: "ok" };
    case "parcial":
      return { clave: "entregado_parcial", etiqueta: "Entregado en parte", paso: 4, tono: "ok" };
    case "no_entregado":
      return { clave: "no_entregado", etiqueta: "No se pudo entregar", paso: 3, tono: "error" };
    case "anulado":
      return { clave: "anulado", etiqueta: "Anulado por la distribuidora", paso: 2, tono: "error" };
    default:
      return { clave: "confirmado", etiqueta: "Confirmado", paso: 2, tono: "curso" };
  }
}
function colorTextoSobre(fondoHex) {
  const m = /^#?([0-9a-f]{6})$/i.exec(fondoHex.trim());
  if (!m) return "#ffffff";
  const n = Number.parseInt(m[1], 16);
  const canal = (v) => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  };
  const l = 0.2126 * canal(n >> 16 & 255) + 0.7152 * canal(n >> 8 & 255) + 0.0722 * canal(n & 255);
  const contrasteBlanco = 1.05 / (l + 0.05);
  const contrasteNegro = (l + 0.05) / 0.0617;
  return contrasteBlanco >= contrasteNegro ? "#ffffff" : "#1c1917";
}
function rutaVolverTienda(ruta) {
  if (typeof ruta !== "string" || ruta.length > 120) return "/";
  return /^\/(?!\/)[A-Za-z0-9/_-]*$/.test(ruta) && !ruta.includes("//") ? ruta : "/";
}
var codigoClienteTienda = (n) => `T-${n}`;

// src/carga.ts
var MOTIVOS_FALTANTE = ["Sin stock", "Roto", "Vencido", "Otro"];
var MOTIVOS_NO_SUBE = ["Sin stock", "No entr\xF3 en el m\xF3vil", "Cliente cancel\xF3", "Otro"];
function conformidadesRequeridas(q) {
  if (q === "ambos") return { encargado: true, chofer: true, cualquiera: false };
  if (q === "encargado") return { encargado: true, chofer: false, cualquiera: false };
  return { encargado: false, chofer: false, cualquiera: true };
}
function cierreListo(q, c) {
  const r = conformidadesRequeridas(q);
  if (r.cualquiera) return c.controlado || c.recibido;
  return (!r.encargado || c.controlado) && (!r.chofer || c.recibido);
}
function faltaParaCerrar(q, c) {
  const r = conformidadesRequeridas(q);
  if (r.cualquiera) return c.controlado || c.recibido ? [] : ["alguno"];
  const falta = [];
  if (r.encargado && !c.controlado) falta.push("encargado");
  if (r.chofer && !c.recibido) falta.push("chofer");
  return falta;
}
function cyrb53(texto2, semilla = 0) {
  let h1 = 3735928559 ^ semilla;
  let h2 = 1103547991 ^ semilla;
  for (let i = 0; i < texto2.length; i++) {
    const c = texto2.charCodeAt(i);
    h1 = Math.imul(h1 ^ c, 2654435761);
    h2 = Math.imul(h2 ^ c, 1597334677);
  }
  h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507) ^ Math.imul(h2 ^ h2 >>> 13, 3266489909);
  h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507) ^ Math.imul(h1 ^ h1 >>> 13, 3266489909);
  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}
function huellaCarga(pedidos) {
  const texto2 = [...pedidos].sort((a, b) => a.id < b.id ? -1 : a.id > b.id ? 1 : 0).map(
    (p) => `${p.id}:${p.cargado ? 1 : 0}:${[...p.items].sort((a, b) => a.id < b.id ? -1 : a.id > b.id ? 1 : 0).map((i) => `${i.id}=${i.bultos}`).join(",")}`
  ).join("|");
  return cyrb53(texto2).toString(36);
}
var pedidoDe = (i) => i.bultos_pedidos ?? i.bultos;
function estadoControlPedido(p) {
  if (!p.cargado) return "pendiente";
  return p.items.some((i) => i.bultos < pedidoDe(i)) ? "en_parte" : "completo";
}
function faltantesPedido(items) {
  return items.filter((i) => i.bultos < pedidoDe(i)).map((i) => ({
    articulo_id: i.articulo_id,
    nombre: i.nombre,
    bultos: pedidoDe(i) - i.bultos,
    motivo: i.motivo_carga
  }));
}
function textoFaltantes(faltantes, max = 6) {
  const partes2 = faltantes.slice(0, max).map((f) => `\u2212 ${f.bultos} ${f.nombre}${f.motivo ? ` (${f.motivo.trim().toLowerCase()})` : ""}`);
  if (faltantes.length > max) partes2.push(`y ${faltantes.length - max} m\xE1s`);
  return partes2.join(" \xB7 ");
}
function resumirControl(pedidos) {
  const r = {
    pedidos: pedidos.length,
    bultos: 0,
    bultos_pedidos: 0,
    completos: [],
    en_parte: [],
    no_suben: [],
    diferencias: []
  };
  const porArticulo = /* @__PURE__ */ new Map();
  const fila = (i) => {
    let f = porArticulo.get(i.articulo_id);
    if (!f) {
      f = {
        articulo_id: i.articulo_id,
        codigo: i.codigo,
        nombre: i.nombre,
        pedidos: 0,
        suben: 0,
        faltan: 0,
        motivos: []
      };
      porArticulo.set(i.articulo_id, f);
    }
    return f;
  };
  const motivo = (f, m) => {
    const t = m?.trim();
    if (t && !f.motivos.includes(t)) f.motivos.push(t);
  };
  for (const p of pedidos) {
    const pedidosBultos = p.items.reduce((s, i) => s + pedidoDe(i), 0);
    r.bultos_pedidos += pedidosBultos;
    if (!p.cargado) {
      r.no_suben.push({
        pedido_id: p.id,
        numero_visible: p.numero_visible,
        cliente: p.cliente.nombre,
        bultos: pedidosBultos,
        motivo: p.no_cargado_motivo
      });
      for (const i of p.items) {
        const f = fila(i);
        f.pedidos += pedidoDe(i);
        motivo(f, p.no_cargado_motivo ?? "No sube");
      }
      continue;
    }
    const bultos = p.items.reduce((s, i) => s + i.bultos, 0);
    r.bultos += bultos;
    for (const i of p.items) {
      const f = fila(i);
      f.pedidos += pedidoDe(i);
      f.suben += i.bultos;
      if (i.bultos < pedidoDe(i)) motivo(f, i.motivo_carga);
    }
    const base = { pedido_id: p.id, numero_visible: p.numero_visible, cliente: p.cliente.nombre, bultos };
    if (estadoControlPedido(p) === "en_parte")
      r.en_parte.push({ ...base, bultos_pedidos: pedidosBultos, faltantes: faltantesPedido(p.items) });
    else r.completos.push(base);
  }
  for (const f of porArticulo.values()) {
    f.faltan = f.pedidos - f.suben;
    if (f.faltan > 0) r.diferencias.push(f);
  }
  r.diferencias.sort(
    (a, b) => a.codigo.localeCompare(b.codigo, "es", { numeric: true }) || a.nombre.localeCompare(b.nombre, "es")
  );
  return r;
}

// src/pedido-venta.ts
function diferenciasItems(antes, despues) {
  const juntar = (lista) => {
    const m = /* @__PURE__ */ new Map();
    for (const i of lista) {
      const ya = m.get(i.articulo_id);
      m.set(i.articulo_id, ya ? { ...ya, bultos: ya.bultos + i.bultos } : { ...i });
    }
    return m;
  };
  const a = juntar(antes);
  const d = juntar(despues);
  const r = [];
  for (const [id, x] of d) {
    const previo = a.get(id);
    if (!previo) r.push({ tipo: "entra", articulo_id: id, nombre: x.nombre, bultos: x.bultos });
    else if (previo.bultos !== x.bultos)
      r.push({ tipo: "cambia", articulo_id: id, nombre: x.nombre, antes: previo.bultos, despues: x.bultos });
  }
  for (const [id, x] of a)
    if (!d.has(id)) r.push({ tipo: "sale", articulo_id: id, nombre: x.nombre, bultos: x.bultos });
  return r;
}
function textoCambios(cambios, max = 6) {
  const uno = (c) => c.tipo === "entra" ? `+ ${c.bultos} ${c.nombre}` : c.tipo === "sale" ? `\u2212 ${c.nombre}` : `${c.nombre} ${c.antes} \u2192 ${c.despues}`;
  const partes2 = cambios.slice(0, max).map(uno);
  if (cambios.length > max) partes2.push(`y ${cambios.length - max} cambios m\xE1s`);
  return partes2.join(" \xB7 ");
}
var EVENTOS_SEGUIMIENTO = [
  "recibido",
  "modificado",
  "aprobado",
  "rechazado",
  "cancelado",
  /** Al cerrar la carga, el pedido sube en parte: lo que no va y por qué (decisión D54). */
  "sale_con_cambios",
  "en_camino",
  "entregado",
  "entregado_parcial",
  "no_entregado",
  "anulado",
  "reprogramado"
];
function diaEntrega(fecha) {
  const dia = DIAS_SEMANA[(/* @__PURE__ */ new Date(`${fecha}T12:00:00Z`)).getUTCDay()];
  return `el ${DIA_SEMANA_ETIQUETA[dia].toLowerCase()} ${fecha.slice(8, 10)}/${fecha.slice(5, 7)}`;
}
function textosSeguimiento(d, nombres) {
  const n = d.numero_visible;
  const e = nombres.empresa;
  const quien = d.quien?.trim() || e;
  const cambios = d.cambios?.length ? `: ${textoCambios(d.cambios)}` : "";
  const total = d.monto != null ? ` Total ${formatoGs(d.monto)}.` : "";
  const motivo = d.motivo?.trim();
  switch (d.evento) {
    case "recibido": {
      const bultos = d.bultos != null ? ` (${d.bultos} ${d.bultos === 1 ? "bulto" : "bultos"})` : "";
      if (d.por === "vendedor")
        return {
          cliente: `${quien} tom\xF3 tu pedido ${n}${bultos} en tu local.${total} Te avisamos ac\xE1 cuando lo confirmemos.`,
          gestion: `${quien} (preventista) tom\xF3 el pedido ${n} de ${nombres.cliente}${bultos}.${total}`
        };
      return {
        cliente: `Recibimos tu pedido ${n}${bultos}.${total} Te avisamos ac\xE1 cuando lo confirmemos.`,
        gestion: `${nombres.cliente} hizo el pedido ${n}${bultos}.${total}`
      };
    }
    case "modificado":
      return d.por === "cliente" ? {
        cliente: `Modificaste tu pedido ${n}${cambios}.${total}`,
        gestion: `${nombres.cliente} modific\xF3 el pedido ${n}${cambios}.${total}`
      } : {
        cliente: `${e} cambi\xF3 tu pedido ${n}${cambios}.${total}`,
        gestion: `${quien} cambi\xF3 el pedido ${n}${cambios}.${total}`
      };
    case "aprobado": {
      const cuando = d.fecha_entrega ? ` Te llega ${diaEntrega(d.fecha_entrega)}.` : "";
      return {
        cliente: `${e} confirm\xF3 tu pedido ${n}.${cuando}`,
        gestion: d.por === "sistema" ? `Pedido ${n} aprobado autom\xE1ticamente.${cuando.replace("Te llega", "Entrega")}` : `${quien} aprob\xF3 el pedido ${n}.${cuando.replace("Te llega", "Entrega")}`
      };
    }
    case "rechazado":
      return {
        cliente: `${e} no aprob\xF3 tu pedido ${n}.${motivo ? ` Motivo: ${motivo}.` : ""}`,
        gestion: `${quien} rechaz\xF3 el pedido ${n}.${motivo ? ` Motivo: ${motivo}.` : ""}`
      };
    case "cancelado":
      return { cliente: `Cancelaste tu pedido ${n}.`, gestion: `${nombres.cliente} cancel\xF3 el pedido ${n}.` };
    case "sale_con_cambios": {
      const faltan = d.faltantes?.length ? `: ${textoFaltantes(d.faltantes)}` : "";
      return {
        cliente: `Tu pedido ${n} sale con cambios${faltan}.${total}`,
        gestion: `El pedido ${n} sale con cambios${faltan}.${total}`
      };
    }
    case "en_camino":
      return { cliente: `Tu pedido ${n} est\xE1 en camino.`, gestion: `El pedido ${n} sali\xF3 en reparto.` };
    case "entregado":
      return { cliente: `Entregamos tu pedido ${n}. \xA1Gracias!`, gestion: `Pedido ${n} entregado.` };
    case "entregado_parcial": {
      const parte = d.entregados != null && d.bultos != null ? `: llegaron ${d.entregados} de ${d.bultos} bultos` : "";
      return {
        cliente: `Entregamos una parte de tu pedido ${n}${parte}.`,
        gestion: `Pedido ${n} entregado en parte${parte}.`
      };
    }
    case "no_entregado":
      return {
        cliente: `No pudimos entregar tu pedido ${n}${motivo ? ` (${motivo})` : ""}. Te vamos a contactar para coordinar.`,
        gestion: `No se pudo entregar el pedido ${n}${motivo ? ` (${motivo})` : ""}.`
      };
    case "anulado":
      return {
        cliente: `${e} anul\xF3 tu pedido ${n}. Escribinos si ten\xE9s dudas.`,
        gestion: `Se anul\xF3 el pedido de traslado del ${n}.`
      };
    case "reprogramado": {
      const cuando = d.fecha_entrega ? ` ${diaEntrega(d.fecha_entrega)}` : "";
      return {
        cliente: `Volvemos a llevar tu pedido ${n}${cuando}.`,
        gestion: `El pedido ${n} se reprogram\xF3${cuando ? ` para${cuando}` : ""}.`
      };
    }
  }
}
var avisaAlCliente = (d) => d.por === "vendedor" || d.por !== "cliente" && d.evento !== "recibido";

// src/permisos.ts
var AREAS_PERMISO = [
  "pedidos",
  "deposito",
  "reparto",
  "caja",
  "informes",
  "catalogos",
  "administracion",
  "apps"
];
var AREA_PERMISO_ETIQUETA = {
  pedidos: {
    nombre: "Pedidos y clientes",
    descripcion: "Lo que piden los comercios: la tienda, los pedidos de traslado y la ficha de cada cliente.",
    icono: "receipt_long"
  },
  deposito: {
    nombre: "Dep\xF3sito",
    descripcion: "Lo que sube a cada cami\xF3n: el control de la carga, los m\xF3viles y las impresoras.",
    icono: "fact_check"
  },
  reparto: {
    nombre: "Reparto en la calle",
    descripcion: "Seguir el d\xEDa: el mapa en vivo, las rutas, las alertas y el chat con los choferes.",
    icono: "route"
  },
  caja: {
    nombre: "Caja y facturaci\xF3n",
    descripcion: "La plata y los papeles: rendiciones de los choferes, facturas y notas.",
    icono: "payments"
  },
  informes: {
    nombre: "Informes",
    descripcion: "Los n\xFAmeros del negocio, sin datos de contacto de los clientes.",
    icono: "bar_chart"
  },
  catalogos: {
    nombre: "Cat\xE1logos",
    descripcion: "Lo que se vende y d\xF3nde se reparte: art\xEDculos, precios y zonas.",
    icono: "sell"
  },
  administracion: {
    nombre: "Administraci\xF3n",
    descripcion: "El personal, sus roles y las reglas de la empresa.",
    icono: "settings"
  },
  apps: {
    nombre: "Apps del celular",
    descripcion: "Para el que trabaja en la calle: la app del chofer y la tienda en modo vendedor.",
    icono: "smartphone"
  }
};
var CATALOGO_PERMISOS = {
  // Pedidos y clientes
  "pedidos.ver": {
    area: "pedidos",
    nombre: "Ver pedidos de traslado",
    descripcion: "La lista de pedidos de traslado y el detalle de cada uno, con sus comprobantes."
  },
  "pedidos.editar": {
    area: "pedidos",
    nombre: "Cargar y cambiar pedidos",
    descripcion: "Crear pedidos de traslado, cambiarles art\xEDculos, fecha o m\xF3vil, anularlos y reprogramarlos. Importar pedidos de Excel."
  },
  "tienda.aprobar": {
    area: "pedidos",
    nombre: "Aprobar pedidos de la tienda",
    descripcion: "Ver los pedidos que llegan de la tienda y de los preventistas, corregirlos, aprobarlos o rechazarlos."
  },
  "clientes.ver": {
    area: "pedidos",
    nombre: "Ver clientes",
    descripcion: "La lista de clientes y su ficha, con el tel\xE9fono, la direcci\xF3n y la ubicaci\xF3n."
  },
  "clientes.editar": {
    area: "pedidos",
    nombre: "Cargar y cambiar clientes",
    descripcion: "Dar de alta y editar clientes (con c\xF3mo figuran en el padr\xF3n de la DNIT y la consulta del RUC en SIFEN), marcar su ubicaci\xF3n, darles acceso a la tienda, aprobar los registros nuevos y armar la cartera de cada preventista."
  },
  "chat.clientes": {
    area: "pedidos",
    nombre: "Chat con los comercios",
    descripcion: "Leer y contestar lo que escriben los comercios desde la tienda."
  },
  // Depósito
  "carga.controlar": {
    area: "deposito",
    nombre: "Controlar la carga",
    descripcion: "Control de carga: contar lo que sube a cada m\xF3vil, cerrar la carga, pasar pedidos entre m\xF3viles, la hoja de carga y las etiquetas."
  },
  "moviles.editar": {
    area: "deposito",
    nombre: "M\xF3viles",
    descripcion: "Dar de alta y cambiar los m\xF3viles, su capacidad, su chofer habitual y sus documentos."
  },
  "impresoras.estacion": {
    area: "deposito",
    nombre: "Estaci\xF3n de impresi\xF3n",
    descripcion: "Marcar la computadora que imprime sola y manejar la cola de impresi\xF3n (reimprimir, descartar)."
  },
  // Reparto en la calle
  "mapa.ver": {
    area: "reparto",
    nombre: "Ver el mapa en vivo",
    descripcion: "La pantalla Hoy: d\xF3nde est\xE1 cada m\xF3vil y c\xF3mo va el d\xEDa."
  },
  "rutas.ver": {
    area: "reparto",
    nombre: "Ver rutas",
    descripcion: "Las rutas de cada m\xF3vil con sus paradas, el recorrido y lo que pas\xF3 en cada entrega."
  },
  "rutas.editar": {
    area: "reparto",
    nombre: "Cambiar rutas",
    descripcion: "Optimizar o reordenar una ruta, agregar un pedido urgente, deshacer una entrega y operar la ruta en lugar del chofer."
  },
  "alertas.ver": {
    area: "reparto",
    nombre: "Alertas",
    descripcion: "Ver las alertas del reparto (atrasos, m\xF3viles quietos, la estaci\xF3n sin imprimir) y darlas por resueltas."
  },
  "chat.choferes": {
    area: "reparto",
    nombre: "Chat con los choferes",
    descripcion: "Conversar con los choferes y con el personal, y armar grupos."
  },
  // Caja y facturación
  "rendiciones.recibir": {
    area: "caja",
    nombre: "Recibir rendiciones",
    descripcion: "Ver lo que trae cada chofer al cerrar el d\xEDa (efectivo, QR, cuenta corriente) y darle recibido."
  },
  "comprobantes.ver": {
    area: "caja",
    nombre: "Ver comprobantes",
    descripcion: "Facturas, notas de cr\xE9dito y d\xE9bito, remisiones y comprobantes internos: verlos e imprimirlos."
  },
  "comprobantes.emitir": {
    area: "caja",
    nombre: "Facturar",
    descripcion: "Facturar un pedido, hacer notas de cr\xE9dito y d\xE9bito, emitir o descartar las propuestas y, con la factura electr\xF3nica, reenviarla a SIFEN o consultar su estado."
  },
  "comprobantes.anular": {
    area: "caja",
    nombre: "Anular comprobantes",
    descripcion: "Anular una factura o una nota con su motivo (el n\xFAmero no vuelve); con la factura electr\xF3nica, cancelarla en SIFEN e inutilizar los n\xFAmeros salteados."
  },
  "facturacion.configurar": {
    area: "caja",
    nombre: "Configurar la facturaci\xF3n",
    descripcion: "Datos fiscales de la empresa, timbrados, puntos de expedici\xF3n, qu\xE9 documento sale y en qu\xE9 momento, y la factura electr\xF3nica: el certificado, el c\xF3digo de seguridad (CSC), probar con SIFEN y pasar a producci\xF3n."
  },
  // Informes
  "reportes.ver": {
    area: "informes",
    nombre: "Ver reportes",
    descripcion: "Resumen del d\xEDa, entregas fallidas, ventas y visitas de los preventistas, y exportar a Excel. Sin tel\xE9fonos ni direcciones de los clientes."
  },
  // Catálogos
  "articulos.editar": {
    area: "catalogos",
    nombre: "Art\xEDculos",
    descripcion: "Dar de alta y cambiar art\xEDculos, sus c\xF3digos de barras, fotos y stock."
  },
  "precios.editar": {
    area: "catalogos",
    nombre: "Precios",
    descripcion: "Las listas de precios y el precio de cada art\xEDculo."
  },
  "zonas.editar": {
    area: "catalogos",
    nombre: "Zonas",
    descripcion: "Dibujar y cambiar las zonas de reparto."
  },
  // Administración
  "usuarios.ver": {
    area: "administracion",
    nombre: "Ver el personal",
    descripcion: "La lista del personal con sus roles y tel\xE9fonos. Darle a un chofer el c\xF3digo para entrar, si la empresa lo usa."
  },
  "usuarios.gestionar": {
    area: "administracion",
    nombre: "Usuarios y roles",
    descripcion: "Crear usuarios, darles roles, desactivarlos, cerrar sus sesiones y armar roles propios. Quien lo tiene puede darse cualquier permiso."
  },
  "configuracion.editar": {
    area: "administracion",
    nombre: "Configuraci\xF3n",
    descripcion: "Las reglas de la empresa, los dep\xF3sitos, la marca de la tienda, la impresi\xF3n autom\xE1tica y el servicio de mensajes."
  },
  "mensajes.ver": {
    area: "administracion",
    nombre: "Mensajes enviados",
    descripcion: "Los SMS y correos que mand\xF3 el sistema, con su estado."
  },
  // Apps del celular
  app_chofer: {
    area: "apps",
    nombre: "App del chofer",
    descripcion: "Entrar a la app del chofer: cargar, salir a ruta, entregar, cobrar y rendir."
  },
  "preventa.pedir": {
    area: "apps",
    nombre: "Preventa",
    descripcion: "Entrar a la tienda como vendedor: su cartera de clientes, las visitas del d\xEDa y tomar pedidos en el local."
  }
};
var PERMISOS = Object.keys(CATALOGO_PERMISOS);
var esPermiso = (v) => typeof v === "string" && Object.prototype.hasOwnProperty.call(CATALOGO_PERMISOS, v);
var permisosDelArea = (area) => PERMISOS.filter((p) => CATALOGO_PERMISOS[p].area === area);
var PERMISOS_APPS = ["app_chofer", "preventa.pedir"];
var PERMISOS_PANEL = PERMISOS.filter((p) => !PERMISOS_APPS.includes(p));
var PLANTILLAS_ROL = [
  "administrador",
  "encargado",
  "pedidos",
  "deposito",
  "cajero",
  "monitoreo",
  "informes",
  "chofer",
  "preventista"
];
var PEDIDOS = [
  "pedidos.ver",
  "pedidos.editar",
  "tienda.aprobar",
  "clientes.ver",
  "clientes.editar",
  "chat.clientes"
];
var DEPOSITO = ["carga.controlar", "moviles.editar", "impresoras.estacion", "pedidos.ver"];
var CAJERO = ["rendiciones.recibir", "comprobantes.ver", "comprobantes.emitir", "pedidos.ver"];
var MONITOREO = ["mapa.ver", "rutas.ver", "alertas.ver", "chat.choferes"];
var FUERA_DEL_ENCARGADO = [
  "usuarios.gestionar",
  "configuracion.editar",
  "facturacion.configurar",
  "comprobantes.anular",
  "preventa.pedir"
];
var PLANTILLAS = {
  administrador: {
    nombre: "Administrador",
    quien: "El due\xF1o o el gerente.",
    descripcion: "Todo, incluidos la configuraci\xF3n, los usuarios y la facturaci\xF3n.",
    permisos: "todos"
  },
  encargado: {
    nombre: "Encargado (todo lo operativo)",
    quien: "El encargado del dep\xF3sito de siempre.",
    descripcion: "Pedidos, dep\xF3sito, caja y monitoreo juntos, adem\xE1s de cat\xE1logos, reportes y la app del chofer: todo lo que hac\xEDa el encargado antes de los roles. No toca usuarios, configuraci\xF3n ni datos fiscales, ni anula comprobantes.",
    permisos: PERMISOS.filter((p) => !FUERA_DEL_ENCARGADO.includes(p))
  },
  pedidos: {
    nombre: "Pedidos",
    quien: "Recibe y valida los pedidos.",
    descripcion: "La tienda (aprobar, corregir, rechazar), los pedidos de traslado, los clientes y el chat con los comercios.",
    permisos: PEDIDOS
  },
  deposito: {
    nombre: "Dep\xF3sito",
    quien: "Controla lo que sube al cami\xF3n.",
    descripcion: "Control de carga, hoja de carga, etiquetas, m\xF3viles e impresoras.",
    permisos: DEPOSITO
  },
  cajero: {
    nombre: "Cajero",
    quien: "La caja y las cobranzas.",
    descripcion: "Recibir las rendiciones, ver los pedidos, facturar y hacer notas de cr\xE9dito y d\xE9bito.",
    permisos: CAJERO
  },
  monitoreo: {
    nombre: "Monitoreo",
    quien: "Supervisa el reparto.",
    descripcion: "Hoy (el mapa en vivo), las rutas, las alertas y el chat con los choferes. Mira, no modifica.",
    permisos: MONITOREO
  },
  informes: {
    nombre: "Informes",
    quien: "La gerencia o el contador.",
    descripcion: "Solo los reportes, sin datos de contacto de los clientes ni pantallas operativas.",
    permisos: ["reportes.ver"]
  },
  chofer: {
    nombre: "Chofer",
    quien: "Reparte.",
    descripcion: "Su app: la carga, la ruta, las entregas, los cobros y la rendici\xF3n.",
    permisos: ["app_chofer"]
  },
  preventista: {
    nombre: "Preventista",
    quien: "El vendedor en la calle.",
    descripcion: "Su cartera de clientes y las visitas del d\xEDa; toma el pedido en el local desde el celular, con la tienda en modo vendedor.",
    permisos: ["preventa.pedir"]
  }
};
var esPlantillaRol = (v) => PLANTILLAS_ROL.includes(v);
var permisosDePlantilla = (p) => {
  const d = PLANTILLAS[p].permisos;
  return d === "todos" ? [...PERMISOS] : [...d];
};
var PLANTILLA_DE_ROL = {
  admin: "administrador",
  encargado: "encargado",
  chofer: "chofer",
  preventista: "preventista"
};
function permisosDeRol(r) {
  if (r.plantilla && esPlantillaRol(r.plantilla)) return permisosDePlantilla(r.plantilla);
  if (r.plantilla) return [];
  return PERMISOS.filter((p) => r.permisos.includes(p));
}
function permisosDeRoles(roles) {
  const todos = /* @__PURE__ */ new Set();
  for (const r of roles) for (const p of permisosDeRol(r)) todos.add(p);
  return PERMISOS.filter((p) => todos.has(p));
}
var plantillasCon = (p) => PLANTILLAS_ROL.filter((x) => permisosDePlantilla(x).includes(p));
var tiene = (permisos, p) => "has" in permisos ? permisos.has(p) : permisos.includes(p);
var tieneAlguno = (permisos, ps) => ps.some((p) => tiene(permisos, p));
function puedeEntrarAApp(app, permisos) {
  if (app === "panel") return tieneAlguno(permisos, PERMISOS_PANEL);
  if (app === "chofer") return tiene(permisos, "app_chofer");
  return tiene(permisos, "preventa.pedir");
}
function perfilDe(permisos) {
  if (tiene(permisos, "usuarios.gestionar")) return "admin";
  if (tiene(permisos, "app_chofer") && !tiene(permisos, "rutas.editar")) return "chofer";
  if (tiene(permisos, "preventa.pedir") && !tieneAlguno(permisos, PERMISOS_PANEL)) return "preventista";
  return "encargado";
}
var PERMISO_IMPORTACION = {
  clientes: "clientes.editar",
  articulos: "articulos.editar",
  precios: "precios.editar",
  moviles: "moviles.editar",
  pedidos: "pedidos.editar"
};
var AVISO_PERMISO = {
  /** Pedido nuevo o modificado de la tienda o de un preventista. */
  pedido_tienda: "tienda.aprobar",
  /** Un comercio se registró en la tienda. */
  cliente_nuevo: "clientes.editar",
  /** Mensaje de un comercio en el chat. */
  mensaje_cliente: "chat.clientes",
  /** Un chofer cerró la ruta: rendición por recibir. */
  rendicion: "rendiciones.recibir",
  /** Alertas del reparto (también la estación de impresión sin responder). */
  alerta: "alertas.ver",
  /** Trabajos de la estación de impresión. */
  estacion: "impresoras.estacion",
  /** Resumen del día. */
  resumen_diario: "reportes.ver",
  /** Alertas de la factura electrónica (D58): rechazados por SIFEN, sin enviar, el certificado por vencer. */
  factura_electronica: "comprobantes.emitir"
};

// src/acceso-google.ts
var APPS_PERSONAL = ["panel", "chofer"];
var PROVEEDORES = ["google", "apple", "facebook"];
var NOMBRE_PROVEEDOR = { google: "Google", apple: "Apple", facebook: "Facebook" };
var esProveedor = (v) => PROVEEDORES.includes(v);
var puedeEntrarA = (app, permisos) => puedeEntrarAApp(app, permisos);
var ERRORES_GOOGLE_PERSONAL = [
  "cancelado",
  "google",
  "email_sin_verificar",
  "sin_acceso",
  "desactivado",
  "rol",
  "varias_empresas",
  "no_disponible",
  "vencido",
  /** Facebook (o una cuenta de Apple con el correo oculto) que nadie vinculó desde "Mi cuenta". */
  "sin_vincular",
  /** Al vincular: esa cuenta del proveedor ya está vinculada a otro usuario. */
  "ya_vinculada"
];
var OTRO_INGRESO = "con tu correo y contrase\xF1a";
function mensajeGooglePersonal(error, app, proveedor = "google") {
  const p = NOMBRE_PROVEEDOR[proveedor];
  switch (error) {
    case "cancelado":
      return `No terminaste de elegir tu cuenta de ${p}. Prob\xE1 de nuevo cuando quieras.`;
    case "email_sin_verificar":
      return `Tu cuenta de ${p} no tiene el correo verificado. Verificalo en ${p} o entr\xE1 ${OTRO_INGRESO}.`;
    case "sin_acceso":
      return `Ese correo de ${p} no tiene acceso. Pedile al administrador de tu empresa que te cree el usuario con ese correo.`;
    case "sin_vincular":
      return `Tu cuenta de ${p} todav\xEDa no est\xE1 vinculada. Entr\xE1 ${OTRO_INGRESO} y vinculala desde \xABMi cuenta\xBB.`;
    case "ya_vinculada":
      return `Esa cuenta de ${p} ya est\xE1 vinculada a otro usuario.`;
    case "desactivado":
      return "Tu usuario est\xE1 desactivado. Consult\xE1 con el administrador de tu empresa.";
    case "rol":
      return app === "panel" ? "Tu usuario no tiene permisos para el panel. Si sos chofer, us\xE1 la app del chofer; si no, pedile al administrador que te d\xE9 un rol." : "Tu usuario no tiene la app del chofer entre sus permisos. Consult\xE1 con el administrador de tu empresa.";
    case "varias_empresas":
      return `Ese correo de ${p} est\xE1 en m\xE1s de una empresa y no sabemos a cu\xE1l entrar. Entr\xE1 ${OTRO_INGRESO} o pedile al administrador que deje ese correo en una sola.`;
    case "no_disponible":
      return `El ingreso con ${p} no est\xE1 habilitado. Entr\xE1 ${OTRO_INGRESO}.`;
    case "vencido":
      return `El ingreso con ${p} venci\xF3 o se abri\xF3 en otro navegador. Toc\xE1 \xABContinuar con ${p}\xBB de nuevo.`;
    default:
      return `No pudimos entrar con ${p}. Prob\xE1 de nuevo.`;
  }
}
function leerVueltaGooglePersonal(hash) {
  const p = /* @__PURE__ */ new Map();
  for (const par of hash.replace(/^#/, "").split("&")) {
    const i = par.indexOf("=");
    if (i > 0) p.set(par.slice(0, i), par.slice(i + 1));
  }
  const c = p.get("c") || null;
  const error = p.get("error") || null;
  if (!c && !error) return null;
  const codigo = c && /^[A-Za-z0-9_-]{20,80}$/.test(c) ? c : null;
  const conocido = ERRORES_GOOGLE_PERSONAL.includes(error ?? "");
  const proveedor = p.get("p");
  return {
    codigo,
    error: error ? conocido ? error : "google" : codigo ? null : "google",
    proveedor: esProveedor(proveedor) ? proveedor : "google",
    vincular: p.get("t") === "vincular"
  };
}
var CLAVE_MINIMA = 8;

// src/preventa.ts
var MOTIVOS_NO_COMPRA = ["tiene_stock", "sin_plata", "cerrado", "otro"];
var MOTIVO_NO_COMPRA_ETIQUETA = {
  tiene_stock: "Tiene stock",
  sin_plata: "Sin plata",
  cerrado: "Cerrado",
  otro: "Otro"
};
var RESULTADOS_VISITA = ["pedido", "no_compro"];
var ESTADO_VISITA_ETIQUETA = {
  por_visitar: "Por visitar",
  en_el_local: "En el local",
  con_pedido: "Con pedido",
  no_compro: "No compr\xF3"
};
function estadoVisita(v) {
  if (!v) return "por_visitar";
  if (v.resultado === "pedido") return "con_pedido";
  if (v.resultado === "no_compro") return "no_compro";
  return v.checkin_en ? "en_el_local" : "por_visitar";
}
function diaDeFecha(fecha) {
  const [a, m, d] = fecha.split("-").map(Number);
  return DIAS_SEMANA[new Date(Date.UTC(a, m - 1, d)).getUTCDay()];
}
var tocaVisita = (dias, fecha) => dias.includes(diaDeFecha(fecha));
function ordenarDias(dias) {
  const orden = ["lun", "mar", "mie", "jue", "vie", "sab", "dom"];
  return orden.filter((d) => dias.includes(d));
}
function textoDias(dias) {
  const o = ordenarDias(dias);
  if (!o.length) return "Sin d\xEDas de visita";
  if (o.length === 7) return "Todos los d\xEDas";
  const nombres = {
    lun: "lunes",
    mar: "martes",
    mie: "mi\xE9rcoles",
    jue: "jueves",
    vie: "viernes",
    sab: "s\xE1bado",
    dom: "domingo"
  };
  const t = o.map((d) => nombres[d]);
  const frase = t.length === 1 ? t[0] : `${t.slice(0, -1).join(", ")} y ${t.at(-1)}`;
  return frase.charAt(0).toUpperCase() + frase.slice(1);
}
function distanciaCheckin(local, aca) {
  if (!local || !aca) return null;
  return Math.round(haversineM(local, aca));
}
var efectividad = (conPedido, visitadas) => visitadas > 0 ? Math.round(conPedido / visitadas * 100) : null;

// src/impresion.ts
var DOCUMENTOS_IMPRESION = [
  "pedido",
  "etiqueta",
  "hoja_carga",
  "hoja_carga_controlada",
  "hoja_ruta",
  "recibo_rendicion",
  "comprobante_entrega",
  // Facturación (decisión D57): cada uno puede salir en otra impresora (por ejemplo, la factura en A4).
  "factura",
  "nota_credito",
  "nota_debito",
  "remision"
];
var DOCUMENTO_IMPRESION_ETIQUETA = {
  pedido: "Ticket del pedido",
  etiqueta: "Etiqueta del pedido",
  hoja_carga: "Hoja de carga",
  hoja_carga_controlada: "Hoja de carga controlada",
  hoja_ruta: "Hoja de ruta",
  recibo_rendicion: "Recibo de la rendici\xF3n",
  comprobante_entrega: "Comprobante de entrega",
  factura: "Factura o nota de venta",
  nota_credito: "Nota de cr\xE9dito",
  nota_debito: "Nota de d\xE9bito",
  remision: "Nota de remisi\xF3n"
};
var DOCUMENTO_IMPRESION_AYUDA = {
  pedido: "Para armar en el dep\xF3sito, el remito o el pedido de la tienda que entra",
  etiqueta: "Para pegar en los bultos de cada pedido",
  hoja_carga: "Lo que sube a un m\xF3vil, antes de controlar",
  hoja_carga_controlada: "Con la carga cerrada: qui\xE9n control\xF3, qui\xE9n recibi\xF3 y lo que fue en parte",
  hoja_ruta: "Las paradas en orden, por si el chofer la quiere en papel",
  recibo_rendicion: "La plata que entreg\xF3 el chofer, con lugar para las dos firmas",
  comprobante_entrega: "El que dej\xF3 el chofer, reimpreso desde la ruta o la rendici\xF3n",
  factura: "La factura, la nota de venta o el comprobante interno de un pedido",
  nota_credito: "Por lo que volvi\xF3 o una devoluci\xF3n, vinculada a su factura",
  nota_debito: "Un recargo sobre una factura",
  remision: "La mercader\xEDa que viaja sin factura, al cerrar la carga"
};
var ESTADOS_TRABAJO_IMPRESION = ["pendiente", "imprimiendo", "impreso", "error", "descartado"];
var ESTADO_TRABAJO_IMPRESION_ETIQUETA = {
  pendiente: "Esperando",
  imprimiendo: "Imprimiendo",
  impreso: "Impreso",
  error: "Con error",
  descartado: "Descartado"
};
var REGLAS_IMPRESION = {
  pedido_al_aprobar: { documento: "pedido", titulo: "Al aprobar un pedido de la tienda", que: "Ticket para armar" },
  etiqueta_al_aprobar: {
    documento: "etiqueta",
    titulo: "Al aprobar un pedido de la tienda",
    que: "Etiqueta del pedido"
  },
  pedido_tienda_al_entrar: {
    documento: "pedido",
    titulo: "Al entrar un pedido de la tienda",
    que: "Ticket del pedido por aprobar"
  },
  pedido_al_crear: { documento: "pedido", titulo: "Al cargar un pedido en el panel", que: "Ticket para armar" },
  pedido_urgente: {
    documento: "pedido",
    titulo: "Al agregar un pedido urgente a una ruta en curso",
    que: "Ticket para armar"
  },
  hoja_carga_al_cerrar: {
    documento: "hoja_carga_controlada",
    titulo: "Al cerrar el control de carga",
    que: "Hoja de carga controlada"
  },
  recibo_al_recibir: {
    documento: "recibo_rendicion",
    titulo: "Al recibir una rendici\xF3n",
    que: "Recibo de la rendici\xF3n"
  },
  // Facturación (decisión D57).
  factura_al_emitir: {
    documento: "factura",
    titulo: "Al emitir una factura en el dep\xF3sito",
    que: "Factura, nota de venta o comprobante interno"
  },
  nota_credito_al_emitir: {
    documento: "nota_credito",
    titulo: "Al emitir una nota de cr\xE9dito o de d\xE9bito",
    que: "Nota de cr\xE9dito o de d\xE9bito"
  },
  remision_al_cerrar: {
    documento: "remision",
    titulo: "Al cerrar el control de carga",
    que: "Notas de remisi\xF3n del viaje"
  },
  facturas_al_cerrar: {
    documento: "factura",
    titulo: "Al cerrar el control de carga",
    que: "Facturas de los pedidos del viaje"
  }
};
var REGLAS_IMPRESION_LISTA = Object.keys(REGLAS_IMPRESION);
var texto = (v) => typeof v === "string" && v ? v : null;
function hechoDeEvento(evento, datos = {}) {
  switch (evento) {
    case "pedido_venta.nuevo": {
      const venta = texto(datos.pedido_venta_id);
      if (!venta) return null;
      const traslado = texto(datos.pedido_id);
      if (datos.estado === "aprobado" && traslado)
        return { tipo: "pedido_aprobado", pedido_id: traslado, pedido_venta_id: venta };
      return datos.estado === "por_aprobar" ? { tipo: "pedido_tienda_nuevo", pedido_venta_id: venta } : null;
    }
    case "pedido_venta.estado": {
      const venta = texto(datos.pedido_venta_id);
      const traslado = texto(datos.pedido_id);
      return datos.estado === "aprobado" && venta && traslado ? { tipo: "pedido_aprobado", pedido_id: traslado, pedido_venta_id: venta } : null;
    }
    case "ruta.actualizada": {
      const pedido = texto(datos.pedido_id);
      const ruta = texto(datos.ruta_id);
      return datos.motivo === "pedido_agregado" && pedido && ruta ? { tipo: "pedido_urgente", pedido_id: pedido, ruta_id: ruta } : null;
    }
    case "carga.actualizada": {
      const movil = texto(datos.movil_id);
      const fecha = texto(datos.fecha);
      return datos.motivo === "cerrada" && movil && fecha ? { tipo: "carga_cerrada", movil_id: movil, fecha, ruta_id: texto(datos.ruta_id) } : null;
    }
    case "rendicion.recibida": {
      const r = texto(datos.rendicion_id);
      return r ? { tipo: "rendicion_recibida", rendicion_id: r } : null;
    }
    default:
      return null;
  }
}
function trabajosDeHecho(reglas, h) {
  const t = [];
  const si = (regla, datos, entidad, documento = REGLAS_IMPRESION[regla].documento) => {
    if (reglas[regla]) t.push({ regla, documento, datos, clave: `${regla}:${entidad}` });
  };
  switch (h.tipo) {
    case "pedido_aprobado":
      si("pedido_al_aprobar", { pedido_id: h.pedido_id, modo: "armar" }, h.pedido_id);
      si("etiqueta_al_aprobar", { pedido_id: h.pedido_id }, h.pedido_id);
      break;
    case "pedido_tienda_nuevo":
      si("pedido_tienda_al_entrar", { pedido_venta_id: h.pedido_venta_id, modo: "tienda" }, h.pedido_venta_id);
      break;
    case "pedido_creado":
      si("pedido_al_crear", { pedido_id: h.pedido_id, modo: "armar" }, h.pedido_id);
      break;
    case "pedido_urgente":
      si("pedido_urgente", { pedido_id: h.pedido_id, modo: "armar" }, `${h.pedido_id}:${h.ruta_id}`);
      break;
    case "carga_cerrada":
      si("hoja_carga_al_cerrar", { movil_id: h.movil_id, fecha: h.fecha }, `${h.movil_id}:${h.fecha}`);
      break;
    case "rendicion_recibida":
      si("recibo_al_recibir", { rendicion_id: h.rendicion_id }, h.rendicion_id);
      break;
    case "comprobante_emitido":
      if (!h.en_deposito) break;
      if (h.documento === "factura") si("factura_al_emitir", { comprobante_id: h.comprobante_id }, h.comprobante_id);
      else si("nota_credito_al_emitir", { comprobante_id: h.comprobante_id }, h.comprobante_id, h.documento);
      break;
    case "carga_facturada":
      for (const id of h.remisiones) si("remision_al_cerrar", { comprobante_id: id }, id);
      for (const id of h.facturas) si("facturas_al_cerrar", { comprobante_id: id }, id);
      if (!reglas.facturas_al_cerrar) for (const id of h.nuevas) si("factura_al_emitir", { comprobante_id: id }, id);
      break;
  }
  return t;
}
function estacionSinRespuesta(vistoEn, minutos, ahora = /* @__PURE__ */ new Date()) {
  if (!vistoEn) return true;
  return ahora.getTime() - new Date(vistoEn).getTime() > minutos * 6e4;
}

// src/sifen.ts
var AMBIENTES_SIFEN = ["pruebas", "produccion"];
var AMBIENTE_SIFEN_ETIQUETA = {
  pruebas: "Pruebas (sin valor fiscal)",
  produccion: "Producci\xF3n"
};
var ESTADOS_SIFEN = ["pendiente", "enviado", "aprobado", "aprobado_observacion", "rechazado"];
var ESTADO_SIFEN_ETIQUETA = {
  pendiente: "Por enviar a SIFEN",
  enviado: "Enviado, esperando a SIFEN",
  aprobado: "Aprobado por SIFEN",
  aprobado_observacion: "Aprobado con observaci\xF3n",
  rechazado: "Rechazado por SIFEN"
};
var esAprobadoSifen = (e) => e === "aprobado" || e === "aprobado_observacion";
var TIPOS_EVENTO_SIFEN = [
  "cancelacion",
  "inutilizacion",
  "conformidad",
  "disconformidad",
  "desconocimiento",
  "notificacion"
];
var TIPO_EVENTO_SIFEN_ETIQUETA = {
  cancelacion: "Cancelaci\xF3n",
  inutilizacion: "Inutilizaci\xF3n de n\xFAmeros",
  conformidad: "Conformidad del receptor",
  disconformidad: "Disconformidad del receptor",
  desconocimiento: "Desconocimiento del receptor",
  notificacion: "Notificaci\xF3n de recepci\xF3n"
};
var ESTADOS_EVENTO_SIFEN = ["pendiente", "aprobado", "rechazado"];
var TIPO_DE_SIFEN = {
  factura: 1,
  nota_credito: 5,
  nota_debito: 6,
  remision: 7
};
var DESCRIPCION_TIPO_DE = {
  1: "Factura electr\xF3nica",
  4: "Autofactura electr\xF3nica",
  5: "Nota de cr\xE9dito electr\xF3nica",
  6: "Nota de d\xE9bito electr\xF3nica",
  7: "Nota de remisi\xF3n electr\xF3nica"
};
var esDocumentoElectronico = (t) => TIPO_DE_SIFEN[t] !== void 0;
var plazoCancelacionHoras = (t) => t === "factura" ? 48 : 168;
function venceCancelacion(t, firmadoEn) {
  return new Date(new Date(firmadoEn).getTime() + plazoCancelacionHoras(t) * 36e5);
}
function puedeCancelarse(t, firmadoEn, ahora = /* @__PURE__ */ new Date()) {
  return ahora.getTime() <= venceCancelacion(t, firmadoEn).getTime();
}
var PLAZO_TRANSMISION_HORAS = 72;
var cdcEnBloques = (cdc) => cdc.replace(/(.{4})(?=.)/g, "$1 ");
var TIPOS_CONTRIBUYENTE = [1, 2];
var TIPO_CONTRIBUYENTE_ETIQUETA = {
  1: "Persona f\xEDsica",
  2: "Persona jur\xEDdica"
};
var REGIMENES_SIFEN = {
  1: "R\xE9gimen de Turismo",
  2: "Importador",
  3: "Exportador",
  4: "Maquila",
  5: "Ley N\xB0 60/90",
  6: "R\xE9gimen del Peque\xF1o Productor",
  7: "R\xE9gimen del Mediano Productor",
  8: "R\xE9gimen Contable"
};
var DEPARTAMENTOS_SIFEN = [
  { codigo: 1, nombre: "CAPITAL" },
  { codigo: 2, nombre: "CONCEPCION" },
  { codigo: 3, nombre: "SAN PEDRO" },
  { codigo: 4, nombre: "CORDILLERA" },
  { codigo: 5, nombre: "GUAIRA" },
  { codigo: 6, nombre: "CAAGUAZU" },
  { codigo: 7, nombre: "CAAZAPA" },
  { codigo: 8, nombre: "ITAPUA" },
  { codigo: 9, nombre: "MISIONES" },
  { codigo: 10, nombre: "PARAGUARI" },
  { codigo: 11, nombre: "ALTO PARANA" },
  { codigo: 12, nombre: "CENTRAL" },
  { codigo: 13, nombre: "NEEMBUCU" },
  { codigo: 14, nombre: "AMAMBAY" },
  { codigo: 15, nombre: "PTE. HAYES" },
  { codigo: 16, nombre: "BOQUERON" },
  { codigo: 17, nombre: "ALTO PARAGUAY" },
  { codigo: 18, nombre: "CANINDEYU" },
  { codigo: 19, nombre: "CHACO" },
  { codigo: 20, nombre: "NUEVA ASUNCION" }
];
var nombreDepartamento = (codigo) => DEPARTAMENTOS_SIFEN.find((d) => d.codigo === codigo)?.nombre ?? null;
var UNIDAD_SIFEN = {
  unidad: { codigo: 77, abreviatura: "UNI" },
  caja: { codigo: 131, abreviatura: "BX" },
  display: { codigo: 131, abreviatura: "BX" },
  fardo: { codigo: 137, abreviatura: "BL" },
  pack: { codigo: 133, abreviatura: "PK" },
  bolsa: { codigo: 134, abreviatura: "BG" }
};
var unidadSifen = (unidad) => UNIDAD_SIFEN[unidad ?? ""] ?? UNIDAD_SIFEN.unidad;
function faltanDatosSifen(d) {
  const faltan = [];
  if (!d.razon_social?.trim()) faltan.push("la raz\xF3n social");
  if (!d.ruc?.includes("-")) faltan.push("el RUC con su d\xEDgito verificador");
  if (!d.tipo_contribuyente) faltan.push("el tipo de contribuyente");
  if (!d.actividad_codigo?.trim() || !d.actividad_descripcion?.trim())
    faltan.push("la actividad econ\xF3mica (c\xF3digo y descripci\xF3n)");
  if (!d.direccion_fiscal?.trim()) faltan.push("la direcci\xF3n");
  if (!d.departamento_codigo) faltan.push("el departamento");
  if (!d.ciudad_codigo || !d.ciudad_nombre?.trim()) faltan.push("la ciudad (c\xF3digo y nombre de la tabla de SIFEN)");
  if (!d.telefono_fiscal || d.telefono_fiscal.replace(/\D/g, "").length < 6) faltan.push("el tel\xE9fono");
  if (!d.correo_fiscal?.includes("@")) faltan.push("el correo");
  return faltan;
}
var tipoContribuyenteDeRuc = (ruc) => Number(ruc.split("-")[0]) >= 8e7 ? 2 : 1;

// src/padron-dnit.ts
var SITUACIONES_CONTRIBUYENTE = ["activo", "suspendido", "cancelado", "bloqueado", "otro"];
var sinTildes = (texto2) => texto2.normalize("NFD").replace(/[̀-ͯ]/g, "");
function situacionDelEstadoDnit(estado) {
  const t = sinTildes(estado).trim().toUpperCase();
  if (t === "ACTIVO") return "activo";
  if (t.startsWith("SUSPENSION")) return "suspendido";
  if (t.startsWith("CANCELADO")) return "cancelado";
  if (t.startsWith("BLOQUEADO")) return "bloqueado";
  return "otro";
}
var ETIQUETA_SITUACION = {
  activo: "Activo",
  suspendido: "Suspensi\xF3n temporal",
  cancelado: "Cancelado",
  bloqueado: "Bloqueado"
};
function etiquetaEstadoDnit(c) {
  if (c.situacion !== "otro") return ETIQUETA_SITUACION[c.situacion];
  const texto2 = c.estado.trim().toLowerCase();
  return texto2.charAt(0).toUpperCase() + texto2.slice(1);
}
function tonoSituacionDnit(s) {
  if (s === "activo") return "exito";
  return s === "cancelado" || s === "bloqueado" ? "peligro" : "aviso";
}
var RUC_CONSULTA = /^(\d{1,9}[A-Z]?)(?:-(\d))?$/;
function normalizarDocumentoConsulta(texto2) {
  const limpio = texto2.trim().toUpperCase().replace(/[\s.]/g, "").replace(/[‐-―−]/g, "-");
  const m = RUC_CONSULTA.exec(limpio);
  const ruc = m?.[1];
  if (!m || !ruc || ruc.startsWith("0")) return null;
  return { ruc, dvEscrito: m[2] === void 0 ? null : Number(m[2]) };
}
var DIGITOS_MINIMOS_CONSULTA_DNIT = 5;
var MAXIMO_RESULTADOS_BUSQUEDA_DNIT = 10;
var PALABRAS_BUSQUEDA_DNIT = { maximo: 5, letrasMinimas: 3, letrasUtilesMinimas: 4 };
var DIGITOS_MINIMOS_BUSQUEDA_DNIT = 4;
var textoBusquedaDnit = (texto2) => sinTildes(texto2.normalize("NFC")).toLowerCase();
function analizarBusquedaDnit(texto2) {
  const t = textoBusquedaDnit(texto2).trim();
  const conDv = /^([\d.\s]+)[-‐-―−]\s*\d$/.exec(t);
  const digitos = (conDv?.[1] ?? t).replace(/[\s.\-‐-―−]/g, "");
  if (/^\d+$/.test(digitos)) {
    return digitos.length >= DIGITOS_MINIMOS_BUSQUEDA_DNIT && !digitos.startsWith("0") ? { tipo: "ruc", prefijo: digitos } : null;
  }
  const palabras = [
    ...new Set(
      t.replace(/[^a-z0-9]+/g, " ").split(" ").filter((p) => p.length >= PALABRAS_BUSQUEDA_DNIT.letrasMinimas)
    )
  ].slice(0, PALABRAS_BUSQUEDA_DNIT.maximo);
  const utiles = palabras.reduce((suma, p) => suma + p.length, 0);
  return utiles < PALABRAS_BUSQUEDA_DNIT.letrasUtilesMinimas ? null : { tipo: "nombre", palabras };
}
function claveDeBusquedaDnit(texto2) {
  const b = analizarBusquedaDnit(texto2);
  if (!b) return null;
  return b.tipo === "ruc" ? `ruc:${b.prefijo}` : `nombre:${[...b.palabras].sort().join(" ")}`;
}
var TEXTO_BUSQUEDA_CORTA_DNIT = "Escrib\xED al menos un nombre y un apellido, o 4 n\xFAmeros del RUC.";
var pistaDeBusquedaDnit = (texto2) => texto2.trim() === "" || analizarBusquedaDnit(texto2) ? null : TEXTO_BUSQUEDA_CORTA_DNIT;
function documentoParaConsultar(texto2, tipo) {
  if (tipo === "pasaporte" || tipo === "consumidor_final") return null;
  const d = normalizarDocumentoConsulta(texto2);
  if (!d || d.ruc.replace(/\D/g, "").length < DIGITOS_MINIMOS_CONSULTA_DNIT) return null;
  return tipo === "ci" ? { ruc: d.ruc, dvEscrito: null } : d;
}
function esRucEscrito(texto2, tipo) {
  if (tipo === "ruc") return true;
  if (tipo) return false;
  return normalizarDocumentoConsulta(texto2)?.dvEscrito != null;
}
var rucAceptadoEnLaFicha = (documento) => errorRuc(documento) === null;
function datosParaCompletar(c, escrito, tipo) {
  const nombre = c.razon_social;
  if (tipo === "ci") {
    if (/\D/.test(c.ruc)) return { tipoDocumento: "ci", documento: escrito.trim(), nombre, soloNombre: true };
    return { tipoDocumento: "ci", documento: c.ruc, nombre, soloNombre: false };
  }
  if (!c.dv_coincide || !rucAceptadoEnLaFicha(c.documento))
    return { tipoDocumento: "ruc", documento: escrito.trim(), nombre, soloNombre: true };
  return { tipoDocumento: "ruc", documento: c.documento, nombre, soloNombre: false };
}
function datosDeEncontrado(c) {
  return rucAceptadoEnLaFicha(c.documento) ? { tipoDocumento: "ruc", documento: c.documento, nombre: c.razon_social, soloNombre: false } : { tipoDocumento: "ruc", documento: "", nombre: c.razon_social, soloNombre: true };
}
var nombreConLetrasDudosas = (nombre) => /[¿?]/.test(nombre);
var recortarNombreDnit = (nombre, maximo) => nombre.slice(0, maximo).trimEnd();
function avisosDelContribuyente(c, propuesta) {
  const avisos = [];
  if (c.situacion === "cancelado")
    avisos.push({
      tono: "peligro",
      texto: "Este RUC figura cancelado en la DNIT: una factura a su nombre no le sirve. Confirm\xE1 el dato con el cliente."
    });
  else if (c.situacion === "bloqueado")
    avisos.push({
      tono: "peligro",
      texto: "Este RUC figura bloqueado en la DNIT. Confirm\xE1 el dato con el cliente antes de facturarle."
    });
  else if (c.situacion === "suspendido")
    avisos.push({
      tono: "aviso",
      texto: "Este RUC tiene una suspensi\xF3n temporal en la DNIT. Confirm\xE1 el dato con el cliente antes de facturarle."
    });
  else if (c.situacion === "otro")
    avisos.push({ tono: "aviso", texto: `En la DNIT figura \xAB${etiquetaEstadoDnit(c)}\xBB.` });
  if (c.dv_escrito_coincide === false)
    avisos.push({ tono: "aviso", texto: `El d\xEDgito verificador que escribiste no es el de la DNIT: es ${c.dv}.` });
  else if (!c.dv_coincide)
    avisos.push({
      tono: "aviso",
      texto: `La DNIT publica el d\xEDgito ${c.dv}, que no da con la cuenta del RUC: se completa solo el nombre. Confirm\xE1 el RUC con el cliente.`
    });
  if (nombreConLetrasDudosas(c.razon_social))
    avisos.push({
      tono: "aviso",
      texto: "La DNIT publica este nombre con \xAB\xBF\xBB o \xAB?\xBB donde va una letra (una \xD1, una \xDC, una tilde): corregilo antes de guardar."
    });
  if (propuesta.soloNombre && propuesta.tipoDocumento === "ci" && /\D/.test(c.ruc))
    avisos.push({
      tono: "aviso",
      texto: `${c.documento} es un RUC viejo con letra, no un n\xFAmero de c\xE9dula: para cargarlo, eleg\xED RUC como tipo de documento.`
    });
  return avisos;
}

export {
  ROLES,
  MEDIOS_COBRO,
  MEDIO_COBRO_ETIQUETA,
  ESTADOS_PEDIDO,
  ESTADO_PEDIDO_ETIQUETA,
  ESTADOS_RUTA,
  RESULTADOS_PARADA,
  MOTIVOS_NO_ENTREGA,
  MOTIVO_NO_ENTREGA_ETIQUETA,
  TIPOS_COMPROBANTE,
  ESTADOS_RENDICION,
  ORIGENES_UBICACION,
  UBICACION_VERIFICADA,
  ORIGENES_UBICACION_PANEL,
  UNIDADES_BULTO,
  TIPOS_MOVIL,
  ORIGENES_CLIENTE,
  ESTADOS_CLIENTE_TIENDA,
  ESTADO_CLIENTE_TIENDA_ETIQUETA,
  ORIGENES_PEDIDO,
  ESTADOS_PEDIDO_VENTA,
  ESTADO_PEDIDO_VENTA_ETIQUETA,
  DIAS_SEMANA,
  DIA_SEMANA_ETIQUETA,
  TIPOS_OPERACION_SYNC,
  TIPOS_IMPORTACION,
  TIPOS_ALERTA,
  ALERTAS_FACTURACION,
  URGENCIAS,
  CODIGOS_ERROR,
  MAQUINAS,
  puedeTransicionar,
  PEDIDO_EDITABLE,
  TIPOS_DOCUMENTO_FISCAL,
  TIPO_DOCUMENTO_FISCAL_ETIQUETA,
  TIPOS_VENTA,
  esTipoVenta,
  TIPOS_CON_TIMBRADO,
  ESTADOS_COMPROBANTE,
  ESTADO_COMPROBANTE_ETIQUETA,
  EMISORES,
  CONDICIONES_VENTA,
  CONDICION_VENTA_ETIQUETA,
  condicionDeCobro,
  DOCUMENTOS_VENTA_CONFIG,
  DOCUMENTO_VENTA_CONFIG_ETIQUETA,
  MOMENTOS_FACTURACION,
  MOMENTO_FACTURACION_ETIQUETA,
  OPCIONES_REMISION,
  OPCIONES_NOTA_CREDITO,
  tipoDeDocumentoConfig,
  emisorDeDocumentoConfig,
  esDocumentoFiscal,
  planFacturacion,
  viajaSinFactura,
  llevaRemision,
  erroresFacturacion,
  avisosFacturacion,
  calcularDvRuc,
  separarRuc,
  errorRuc,
  normalizarRuc,
  TIPOS_DOCUMENTO_IDENTIDAD,
  TIPO_DOCUMENTO_IDENTIDAD_ETIQUETA,
  errorDocumentoFiscal,
  tipoDocumentoProbable,
  TASAS_IVA,
  TASA_IVA_ETIQUETA,
  liquidarIva,
  totalRenglon,
  liquidarRenglones,
  codigoTresDigitos,
  formatoNumeroComprobante,
  siguienteDeReserva,
  noUsadosDeReserva,
  diferenciaNotaCredito,
  numeroALetras,
  totalEnLetras,
  PARAMETROS_RUTA_POR_DEFECTO,
  haversineKm,
  haversineM,
  puntoDeParada,
  deMinutos,
  tramoViaje,
  metricasRuta,
  optimizarOrden,
  enlacesGoogleMaps,
  enlaceNavegar,
  simplificarRecorrido,
  kmRecorridos,
  calcularRendicion,
  resultadoPorBultos,
  montoEsperado,
  ZONA_HORARIA,
  formatoMiles,
  formatoGs,
  formatoFecha,
  formatoHora,
  hoyISO,
  sumarDias,
  formatoNumeroPedido,
  normalizarTelefono,
  normalizarDocumento,
  documentoSinVerificador,
  normalizarTexto,
  uuidv7,
  ES_UUID,
  normalizarCodigo,
  digitoGs1,
  esGtinValido,
  tipoCodigo,
  variantesCodigo,
  DetectorRafaga,
  Antirrebote,
  TIPOS_ENTIDAD,
  rutaPanel,
  rutaHojaCarga,
  enlacePanel,
  codigoCorto,
  interpretarEnlace,
  numeroPedidoLeido,
  estadoEntregaChat,
  duracionAudio,
  vistaPreviaMensaje,
  MENCION_ASISTENTE,
  mencionaAlAsistente,
  dentroDePlazo,
  SLUGS_RESERVADOS,
  PATRON_SLUG,
  slugDeHost,
  ahoraLocal,
  diaSemana,
  fechasEntregaTienda,
  mediosPagoCliente,
  PASOS_SEGUIMIENTO,
  seguimientoPedidoTienda,
  colorTextoSobre,
  rutaVolverTienda,
  codigoClienteTienda,
  MOTIVOS_FALTANTE,
  MOTIVOS_NO_SUBE,
  conformidadesRequeridas,
  cierreListo,
  faltaParaCerrar,
  huellaCarga,
  estadoControlPedido,
  faltantesPedido,
  textoFaltantes,
  resumirControl,
  diferenciasItems,
  textoCambios,
  EVENTOS_SEGUIMIENTO,
  diaEntrega,
  textosSeguimiento,
  avisaAlCliente,
  AREAS_PERMISO,
  AREA_PERMISO_ETIQUETA,
  CATALOGO_PERMISOS,
  PERMISOS,
  esPermiso,
  permisosDelArea,
  PERMISOS_APPS,
  PERMISOS_PANEL,
  PLANTILLAS_ROL,
  PLANTILLAS,
  esPlantillaRol,
  permisosDePlantilla,
  PLANTILLA_DE_ROL,
  permisosDeRol,
  permisosDeRoles,
  plantillasCon,
  tiene,
  tieneAlguno,
  puedeEntrarAApp,
  perfilDe,
  PERMISO_IMPORTACION,
  AVISO_PERMISO,
  APPS_PERSONAL,
  PROVEEDORES,
  NOMBRE_PROVEEDOR,
  esProveedor,
  puedeEntrarA,
  ERRORES_GOOGLE_PERSONAL,
  mensajeGooglePersonal,
  leerVueltaGooglePersonal,
  CLAVE_MINIMA,
  MOTIVOS_NO_COMPRA,
  MOTIVO_NO_COMPRA_ETIQUETA,
  RESULTADOS_VISITA,
  ESTADO_VISITA_ETIQUETA,
  estadoVisita,
  diaDeFecha,
  tocaVisita,
  ordenarDias,
  textoDias,
  distanciaCheckin,
  efectividad,
  DOCUMENTOS_IMPRESION,
  DOCUMENTO_IMPRESION_ETIQUETA,
  DOCUMENTO_IMPRESION_AYUDA,
  ESTADOS_TRABAJO_IMPRESION,
  ESTADO_TRABAJO_IMPRESION_ETIQUETA,
  REGLAS_IMPRESION,
  REGLAS_IMPRESION_LISTA,
  hechoDeEvento,
  trabajosDeHecho,
  estacionSinRespuesta,
  AMBIENTES_SIFEN,
  AMBIENTE_SIFEN_ETIQUETA,
  ESTADOS_SIFEN,
  ESTADO_SIFEN_ETIQUETA,
  esAprobadoSifen,
  TIPOS_EVENTO_SIFEN,
  TIPO_EVENTO_SIFEN_ETIQUETA,
  ESTADOS_EVENTO_SIFEN,
  TIPO_DE_SIFEN,
  DESCRIPCION_TIPO_DE,
  esDocumentoElectronico,
  plazoCancelacionHoras,
  venceCancelacion,
  puedeCancelarse,
  PLAZO_TRANSMISION_HORAS,
  cdcEnBloques,
  TIPOS_CONTRIBUYENTE,
  TIPO_CONTRIBUYENTE_ETIQUETA,
  REGIMENES_SIFEN,
  DEPARTAMENTOS_SIFEN,
  nombreDepartamento,
  UNIDAD_SIFEN,
  unidadSifen,
  faltanDatosSifen,
  tipoContribuyenteDeRuc,
  SITUACIONES_CONTRIBUYENTE,
  situacionDelEstadoDnit,
  etiquetaEstadoDnit,
  tonoSituacionDnit,
  normalizarDocumentoConsulta,
  DIGITOS_MINIMOS_CONSULTA_DNIT,
  MAXIMO_RESULTADOS_BUSQUEDA_DNIT,
  PALABRAS_BUSQUEDA_DNIT,
  DIGITOS_MINIMOS_BUSQUEDA_DNIT,
  textoBusquedaDnit,
  analizarBusquedaDnit,
  claveDeBusquedaDnit,
  TEXTO_BUSQUEDA_CORTA_DNIT,
  pistaDeBusquedaDnit,
  documentoParaConsultar,
  esRucEscrito,
  rucAceptadoEnLaFicha,
  datosParaCompletar,
  datosDeEncontrado,
  nombreConLetrasDudosas,
  recortarNombreDnit,
  avisosDelContribuyente
};
//# sourceMappingURL=chunk-TPMFWVXV.js.map